import BotonInstructivo from "./BotonInstructivo";
import BotonMapaProceso from "./BotonMapaProceso";
import { useState, useEffect } from "react";
import { subirDatos, bajarDatos, eliminarDato } from "./syncSupabase";
import { generarOP } from "./OrdenTrabajo";
import { authHeader } from './supabase';
const ESTADOS = {
  borrador:  { label: "Borrador",  color: "#6B6FD6", bg: "#E8E9F6" },
  enviada:   { label: "Enviada",   color: "#2A7FFF", bg: "#dbeafe" },
  aprobada:  { label: "Aprobada",  color: "#16a34a", bg: "#dcfce7" },
  rechazada: { label: "Rechazada", color: "#dc2626", bg: "#fee2e2" },
  vencida:   { label: "Vencida",   color: "#d97706", bg: "#fef3c7" },
};
function generarCod(lista) {
  const maxN = lista.length ? Math.max(0,...lista.map(c=>parseInt(c.codigo?.split('-')[2])||0)) : 0;
  return `COT-${new Date().getFullYear()}-${String(maxN+1).padStart(4,'0')}`;
}
function hoy() { return new Date().toISOString().slice(0,10); }
function sumarDias(n) { const d=new Date(); d.setDate(d.getDate()+n); return d.toISOString().slice(0,10); }
function diasHasta(fecha) { return Math.ceil((new Date(fecha)-Date.now())/86400000); }
function calcSubtotal(items) { return items.reduce((a,i)=>a+((Number(i.cantidad)||0)*(Number(i.precio)||0)),0); }
function calcTotal(form) { const s=calcSubtotal(form.items); return form.iva ? Math.round(s*(1+(Number(form.iva_pct)||21)/100)) : s; }
function calcEstucheRigido(f) {
  const L=Number(f.largo)||0, A=Number(f.alto)||0, P=Number(f.prof)||0;
  const vta=Number(f.vuelta)||15;
  const tiraje=Number(f.tiraje_rigido)||0;
  const mg=Number(f.margen_estuche)||0;
  if (L<=0||A<=0||tiraje<=0)
    return {tipo:'rigido',componentes:[],costo_total:0,precio_venta:0,precio_unitario:0,tiraje};
  const getValor = p => p.valor==='personalizado'
    ? (Number(p.valor_custom)||0) : (Number(p.valor)||0);
  const FMT={'70x100':[700,1000],'65x90':[650,900],'50x70':[500,700]};
  let fmtA=Number(f.pliego_custom_a)||0, fmtB=Number(f.pliego_custom_b)||0;
  if (!fmtA && FMT[f.pliego]) [fmtA,fmtB]=FMT[f.pliego];
  const pls = f.pliegos||[];
  const calTapa = getValor(pls.find(p=>p.nombre==='CARTÓN TAPA')||{valor:'1.5'});
  const calBase = getValor(pls.find(p=>p.nombre==='CARTÓN BASE')||{valor:'1.5'});
  const altBase = P>0 ? P : A;
  const GEOM = {
    'LAM TAPA':    [Math.ceil(L+2*calTapa+2*vta), Math.ceil(A+2*calTapa+2*vta)],
    'LAM BASE':    [Math.ceil(L+2*calBase+2*vta), Math.ceil(altBase+2*calBase+2*vta)],
    'CARTÓN TAPA': [Math.ceil(L+2*calTapa),       Math.ceil(A+2*calTapa)],
    'CARTÓN BASE': [Math.ceil(L+2*calBase),        Math.ceil(altBase+2*calBase)],
  };
  const requiereProf = new Set(['LAM BASE','CARTÓN BASE']);
  const componentes = [];
  for (const p of pls) {
    if (!p.activo) continue;
    if (requiereProf.has(p.nombre) && P===0) continue;
    const bocas = Math.max(1, Number(p.bocas)||1);
    const costo_kg = Number(p.costo)||0;
    const valor = getValor(p);
    const [dA, dB] = GEOM[p.nombre]||[Math.ceil(L), Math.ceil(A)];
    const merma = 1 + (Number(p.merma)||10)/100;
    const unidades = Math.max(1, Number(p.unidades)||1);
    const pliegos_n = Math.ceil(Math.ceil((tiraje*unidades)/bocas)*merma);
    let medida;
    if (fmtA>0 && fmtB>0) {
      if (p.material==='cartón gris') {
        medida = parseFloat(((fmtA/1000)*(fmtB/1000)*(valor*600/1000)*pliegos_n).toFixed(2));
      } else if (p.material==='eva') {
        medida = parseFloat(((fmtA/1000)*(fmtB/1000)*pliegos_n).toFixed(2));
      } else {
        medida = parseFloat(((fmtA/1000)*(fmtB/1000)*(valor/1000)*pliegos_n).toFixed(2));
      }
    } else {
      if (p.material==='cartón gris') {
        medida = parseFloat(((dA/1000)*(dB/1000)*(valor*600/1000)*pliegos_n*bocas).toFixed(2));
      } else if (p.material==='eva') {
        medida = parseFloat(((dA/1000)*(dB/1000)*pliegos_n*bocas).toFixed(2));
      } else {
        medida = parseFloat(((dA/1000)*(dB/1000)*(valor/1000)*pliegos_n*bocas).toFixed(2));
      }
    }
    componentes.push({nombre:p.nombre,material:p.material,dA,dB,bocas,pliegos:pliegos_n,peso_kg:medida,costo:Math.round(medida*costo_kg)});
  }
  const costos_fijos = Number(f.costos_fijos)||0;
  const costo_total = componentes.reduce((s,c)=>s+c.costo,0) + costos_fijos;
  const precio_venta = Math.round(costo_total*(1+mg/100));
  const precio_unitario = tiraje>0 ? Math.round(precio_venta/tiraje) : 0;
  return {tipo:'rigido',componentes,costo_total,precio_venta,precio_unitario,tiraje};
}
function calcEstuche(f) {
  if (f.tipo==='rigido') return calcEstucheRigido(f);
  const g=Number(f.gramaje)||300;
  const comp=g<=300?0.3:g<=400?0.4:0.5;
  const L=Number(f.largo)||0, A=Number(f.alto)||0, P=Number(f.prof)||0;
  const pest=Number(f.pestaña)||15, sang=Number(f.sangrado)||3;
  let dA=0, dB=0;
  if (f.modo==='manual') { dA=Number(f.desenv_manual_a)||0; dB=Number(f.desenv_manual_b)||0; }
  else if (L>0&&A>0) {
    if      (f.tipo==='plegadizo')   { dA=L+2*P+pest+4*comp; dB=A+P/2+(P+5)+4*comp; }
    else if (f.tipo==='fondo_auto')  { dA=L+2*P+pest+4*comp; dB=A+P/2+(P*1.5+10)+6*comp; }
    else if (f.tipo==='con_ventana') { dA=L+2*P+pest+4*comp; dB=A+P/2+(P+5)+4*comp; }
    else if (f.tipo==='con_manija')  { dA=L+2*P+pest+4*comp; dB=A+P/2+(P+30)+4*comp; }
  }
  dA=Math.ceil(dA); dB=Math.ceil(dB);
  const PLIEGOS={'70x100':[700,1000],'65x90':[650,900],'50x70':[500,700]};
  let pA=Number(f.pliego_custom_a)||0, pB=Number(f.pliego_custom_b)||0;
  if (!pA && PLIEGOS[f.pliego]) { [pA,pB]=PLIEGOS[f.pliego]; }
  const uA=pA-16, uB=pB-16;
  const almas=uA>0&&uB>0?Math.max(
    Math.floor(uA/(dA+sang))*Math.floor(uB/(dB+sang)),
    Math.floor(uA/(dB+sang))*Math.floor(uB/(dA+sang))
  ):0;
  const peso_u_kg=(dA/1000)*(dB/1000)*(g/1000);
  const tirajes=[];
  if (f.tirajes.t500)  tirajes.push(500);
  if (f.tirajes.t1000) tirajes.push(1000);
  if (f.tirajes.t5000) tirajes.push(5000);
  if (Number(f.tirajes.custom)>0) tirajes.push(Number(f.tirajes.custom));
  const ck=Number(f.costo_kg)||0, mg=Number(f.margen_estuche)||0;
  const rows=tirajes.map(t=>{
    const pliegos=almas>0?Math.ceil(t/almas):0;
    const kg=peso_u_kg*t*1.10;
    const costo=Math.round(kg*ck);
    const precio=Math.round(costo*(1+mg/100));
    return {tiraje:t,pliegos,kg:kg.toFixed(2),costo,precio,pu:t>0?Math.round(precio/t):0};
  });
  return {dA,dB,almas,rows};
}
const FACTOR_PAPEL_CO2 = 0.921;
function calcKgEstuche(item) {
  if (!item.calculadorConfig) return 0;
  const result = calcEstuche(item.calculadorConfig);
  if (result.tipo === 'rigido') {
    return (result.componentes || []).reduce((s, c) => s + (Number(c.peso_kg) || 0), 0);
  }
  const tiraje = Number(item.cantidad) || 0;
  const row = (result.rows || []).find(r => r.tiraje === tiraje);
  return row ? Number(row.kg) : 0;
}
function calcEmisionesItems(items) {
  const kg = (items || []).reduce((s, item) => s + calcKgEstuche(item), 0);
  return { kg, tCO2: kg * FACTOR_PAPEL_CO2 / 1000 };
}
const ITEM_VACIO = { descripcion:'', cantidad:'', precio:'', etSku:'', costeoId:'', costoBase:'', margenPct:'' };
const FORM_VACIO = {
  cliente:'', clienteId:null, razon_social:'', cuit:'', po_cliente:'',
  contacto:'', email:'', telefono:'',
  vendedor:'', fecha:hoy(), fechaVencimiento:sumarDias(7),
  observaciones:'', estado:'borrador',
  items:[{ ...ITEM_VACIO }], version:1,
  iva:true, iva_pct:'21',
  condicion_pago:'contado', anticipo_pct:'',
  demasia:'+/- 3% por método de producción',
  sujeto_originales:false,
  validez_dias:'7',
  tiempo_entrega:'',
  terminaciones:[],
  terminaciones_custom:['','',''],
  codigo_terminaciones:'',
  obs_terminaciones:'',
  mostrar_emisiones:false,
  mostrar_compensacion:false,
  sugerencias_compensacion:null,
};
const ESTUCHE_FORM_INICIAL = {
  modo:'geo', tipo:'plegadizo',
  largo:'', alto:'', prof:'',
  gramaje:'300', pestaña:'15', sangrado:'3',
  pliego:'70x100', pliego_custom_a:'', pliego_custom_b:'',
  costo_kg:'', margen_estuche:'30',
  tirajes:{ t500:true, t1000:true, t5000:false, custom:'' },
  desenv_manual_a:'', desenv_manual_b:'', plano_id:'',
  vuelta:'15', tiraje_rigido:'', tirajes_extra:[], costos_fijos:'0',
  pliegos:[
    {nombre:'LAM TAPA',    material:'papel',       activo:true,  bocas:'2', valor:'170', valor_custom:'', costo:'', merma:'7'},
    {nombre:'LAM BASE',    material:'papel',       activo:true,  bocas:'2', valor:'170', valor_custom:'', costo:'', merma:'7'},
    {nombre:'CARTÓN TAPA', material:'cartón gris', activo:true,  bocas:'3', valor:'1.5', valor_custom:'', costo:'', merma:'5'},
    {nombre:'CARTÓN BASE', material:'cartón gris', activo:true,  bocas:'2', valor:'1.5', valor_custom:'', costo:'', merma:'5'},
    {nombre:'CUNA',        material:'cartulina',   activo:false, bocas:'4', unidades:'1', valor:'240', valor_custom:'', costo:'', merma:'10'},
    {nombre:'GOMA EVA',    material:'eva',         activo:false, bocas:'2', unidades:'1', valor:'-',   valor_custom:'', costo:'', merma:'10'},
  ],
};
const TERMINACIONES_DEF = [
  {code:'S',            label:'S',       desc:'Stamping (hot stamping)'},
  {code:'BAJORRELIEVE', label:'BAJO·R',  desc:'Bajorrelieve'},
  {code:'GOFRADO',      label:'GOF',     desc:'Gofrado'},
  {code:'EMBOSSING',    label:'EMB',     desc:'Embossing'},
  {code:'BRAILLE',      label:'BRAILLE', desc:'Braille (relieve funcional)'},
  {code:'B',            label:'B',       desc:'Barniz'},
  {code:'LAM_MATE',     label:'LAM·M',   desc:'Laminado mate'},
  {code:'LAM_BRILLO',   label:'LAM·B',   desc:'Laminado brillo'},
  {code:'SOFT_TOUCH',   label:'SOFT',    desc:'Soft-touch (terciopelo)'},
  {code:'UV',           label:'UV',      desc:'UV sectorizado'},
  {code:'FOIL',         label:'FOIL',    desc:'Holográfico/foil'},
  {code:'TRQ',          label:'TRQ',     desc:'Troquelado'},
  {code:'ACANALADO',    label:'ACAN',    desc:'Acanalado (microcanal)'},
  {code:'MAILER',       label:'MAILER',  desc:'Laminado con mailer metalizado'},
  {code:'VENTANA_PVC',  label:'VENT',    desc:'Ventana PVC'},
  {code:'IMAN',         label:'IMÁN',    desc:'Cierre magnético'},
  {code:'CHAPITA',      label:'CHAPA',   desc:'Chapita metálica (par del imán)'},
  {code:'RIBBON',       label:'RIBBON',  desc:'Cinta de apertura'},
  {code:'BOLSA',        label:'BOLSA',   desc:'Embolsado individual'},
  {code:'FSC',          label:'FSC',     desc:'FSC certificado'},
];
const TERM_LABEL = TERMINACIONES_DEF.reduce((acc,t)=>({...acc,[t.code]:t.label}),{});
export default function Cotizacion({ onVolver, oscuro, usuario }) {
  const [cots, setCots] = useState([]);
  const [seleccionada, setSeleccionada] = useState(null);
  const [showForm, setShowForm] = useState(false);
  const [editando, setEditando] = useState(false);
  const [form, setForm] = useState(FORM_VACIO);
  const [tabDetalle, setTabDetalle] = useState('datos');
  const [tabForm, setTabForm] = useState('datos');
  const [filtroEstado, setFiltroEstado] = useState('todos');
  const [busqueda, setBusqueda] = useState('');
  const [clientes, setClientes] = useState([]);
  const [specs, setSpecs] = useState([]);
  const [showClienteSelector, setShowClienteSelector] = useState(false);
  const [confirmEliminar, setConfirmEliminar] = useState(null);
  const [costeos, setCosteos] = useState([]);
  const [showEstuche, setShowEstuche] = useState(false);
  const [estucheIdx, setEstucheIdx] = useState(0);
  const [estucheForm, setEstucheForm] = useState(ESTUCHE_FORM_INICIAL);
  const [modoCalc, setModoCalc] = useState('nuevo');
  const [busqRepeticion, setBusqRepeticion] = useState('');
  const [repeticionRef, setRepeticionRef] = useState(null);
  const [precioMillar, setPrecioMillar] = useState(false);
  const [toast, setToast] = useState('');
  const [cargandoCompensacion, setCargandoCompensacion] = useState(false);
  const cerrarEstuche = () => {
    setShowEstuche(false);
    setModoCalc('nuevo');
    setBusqRepeticion('');
    setRepeticionRef(null);
    setPrecioMillar(false);
  };
  // Cierra el modal. Si el borrador quedó vacío (nunca se cargó cliente ni
  // ítems), lo eliminamos para no dejar basura en la lista — si ya tiene
  // algo cargado, el autoguardado ya lo persistió, así que cerramos directo.
  const cerrarForm = () => {
    const vacio = !form.cliente.trim() && form.items.every(i=>!i.descripcion && !i.cantidad && !i.precio);
    if (vacio && form.id) {
      const lista = cots.filter(c=>c.id!==form.id);
      guardarLS(lista);
    }
    setShowForm(false);
    setEditando(false);
  };
  const exportarPDF = (cot) => {
    const PAGO_LABELS = {
      contado:'Contado','30_dias':'30 días','60_dias':'60 días',
      '90_dias':'90 días',anticipo_saldo:'Anticipo + saldo',a_convenir:'A convenir',
    };
    const subtotal = calcSubtotal(cot.items||[]);
    const iva_monto = cot.iva ? Math.round(subtotal*(Number(cot.iva_pct)||21)/100) : 0;
    const total = cot.iva ? subtotal+iva_monto : subtotal;
    const condPago = PAGO_LABELS[cot.condicion_pago]||cot.condicion_pago||'';
    const anticipo = cot.condicion_pago==='anticipo_saldo'&&cot.anticipo_pct
      ? ` (${cot.anticipo_pct}% anticipo)` : '';
    const itemsHTML = (cot.items||[]).map((item,i) => {
      const subt = (Number(item.cantidad)||0)*(Number(item.precio)||0);
      return `<tr>
        <td class="c">${i+1}</td>
        <td class="desc">${item.descripcion||'—'}</td>
        <td class="c">${Number(item.cantidad||0).toLocaleString('es-AR')}</td>
        <td class="r">$${Number(item.precio||0).toLocaleString('es-AR')}</td>
        <td class="r">$${subt.toLocaleString('es-AR')}</td>
      </tr>`;
    }).join('');
    const personalizados = (cot.terminaciones_custom||[]).filter(Boolean);
    const badges = [...(cot.terminaciones||[]), ...personalizados]
      .map(c=>`<span class="tbadge">${TERM_LABEL[c]||c}</span>`).join('');
    const autoCode=[...(cot.terminaciones||[]),...personalizados].map(c=>TERM_LABEL[c]||c).join('+');
    const showTcode=cot.codigo_terminaciones&&cot.codigo_terminaciones!==autoCode;
    const termHTML = (cot.terminaciones?.length>0||personalizados.length>0||cot.codigo_terminaciones) ? `
      <div class="section">
        <div class="stit">Terminaciones</div>
        ${badges?`<div class="tbadges">${badges}</div>`:''}
        ${showTcode?`<div class="tcode">${cot.codigo_terminaciones}</div>`:''}
        ${cot.obs_terminaciones?`<div class="tobs">${cot.obs_terminaciones}</div>`:''}
      </div>` : '';
    let emissionsHTML = '';
    if (cot.mostrar_emisiones) {
      const {kg:emKg,tCO2:emTCO2} = calcEmisionesItems(cot.items||[]);
      let compHTML = '';
      if (cot.mostrar_compensacion && cot.sugerencias_compensacion?.internas?.length > 0) {
        const internasHTML = (cot.sugerencias_compensacion.internas||[]).map(s =>
          `<div style="margin-bottom:5px;padding:6px 8px;background:#EFF6FF;border:1px solid #BFDBFE;border-radius:5px;font-size:10px"><div style="font-weight:700;color:#1d4ed8">${s.titulo}</div><div style="color:#374151">${s.descripcion}</div>${s.proveedor?`<div style="color:#6B7280">🔧 ${s.proveedor}</div>`:''}</div>`
        ).join('');
        const externasHTML = (cot.sugerencias_compensacion.externas||[]).map(s =>
          `<div style="margin-bottom:5px;padding:6px 8px;background:#F0FDF4;border:1px solid #BBF7D0;border-radius:5px;font-size:10px"><div style="font-weight:700;color:#166534">${s.titulo}</div><div style="color:#374151">${s.descripcion}</div>${s.proveedor?`<div style="color:#6B7280">📍 ${s.proveedor}</div>`:''}</div>`
        ).join('');
        compHTML = `<div style="margin-top:8px"><div style="font-size:10px;font-weight:700;color:#1d4ed8;margin-bottom:5px;text-transform:uppercase;letter-spacing:.05em">🏭 Acciones internas</div>${internasHTML}<div style="font-size:10px;font-weight:700;color:#16a34a;margin-bottom:5px;margin-top:8px;text-transform:uppercase;letter-spacing:.05em">🌿 Compensación externa</div>${externasHTML}</div>`;
      }
      emissionsHTML = `<div class="section"><div class="stit">🌱 Huella de Carbono</div><div class="fr"><span class="fk">Emisiones estimadas</span><span class="fv" style="color:#16a34a;font-weight:700">${emTCO2.toFixed(4)} tCO₂eq</span></div><div class="fr"><span class="fk">Base de cálculo</span><span class="fv">${emKg.toFixed(2)} kg papel/cartón × 0.921 kgCO₂eq/kg</span></div>${compHTML}</div>`;
    }
    const html = `<!DOCTYPE html><html lang="es"><head><meta charset="UTF-8"/>
<title>Presupuesto ${cot.codigo||''}</title>
<style>
*{margin:0;padding:0;box-sizing:border-box}
body{font-family:'Segoe UI',Arial,sans-serif;color:#111;font-size:12px;padding:32px 40px;max-width:820px;margin:0 auto}
@media print{body{padding:10mm 12mm}.no-print{display:none!important}@page{margin:10mm}}
.print-btn{display:inline-block;margin-bottom:20px;padding:8px 18px;background:#1C3FAA;color:white;border:none;border-radius:8px;font-size:13px;font-weight:600;cursor:pointer}
.hdr{display:flex;justify-content:space-between;align-items:flex-start;margin-bottom:22px;padding-bottom:14px;border-bottom:2.5px solid #1C3FAA}
.brand-name{font-size:22px;font-weight:800;color:#1C3FAA;letter-spacing:-.5px}
.brand-sub{font-size:11px;color:#6B7280;margin-top:3px}
.doc-num{font-size:15px;font-weight:700;color:#1C3FAA;text-align:right}
.doc-meta{font-size:11px;color:#6B7280;margin-top:4px;line-height:1.7;text-align:right}
.section{margin-bottom:16px}
.stit{font-size:10px;font-weight:700;color:#1C3FAA;text-transform:uppercase;letter-spacing:.08em;margin-bottom:6px;padding-bottom:3px;border-bottom:1px solid #E5E7EB}
.fr{display:flex;gap:4px;margin-bottom:3px}
.fk{color:#6B7280;min-width:120px;font-size:12px}
.fv{color:#111;font-weight:500;font-size:12px}
table.it{width:100%;border-collapse:collapse;margin-bottom:4px}
table.it thead th{background:#1C3FAA;color:white;padding:7px 10px;text-align:left;font-size:11px;font-weight:600}
table.it tbody td{padding:7px 10px;border-bottom:1px solid #F3F4F6;vertical-align:top}
table.it tbody tr:nth-child(even){background:#F9FAFB}
.c{text-align:center;color:#6B7280}.desc{font-weight:600}.r{text-align:right}
.tbadges{display:flex;flex-wrap:wrap;gap:5px;margin-bottom:6px}
.tbadge{background:#2A7FFF;color:white;padding:2px 9px;border-radius:20px;font-size:11px;font-weight:700}
.tcode{font-family:monospace;font-weight:700;font-size:13px;color:#1C3FAA;background:#EFF6FF;border-radius:6px;padding:6px 10px;margin-bottom:5px}
.tobs{font-size:11px;color:#374151;background:#F9FAFB;border-radius:6px;padding:6px 10px}
.dembox{background:#FFFBEB;border:1px solid #FDE68A;border-radius:6px;padding:7px 10px;margin-bottom:5px;font-size:12px}
.dembox b{color:#854D0E}
.orig{background:#DBEAFE;color:#1D4ED8;border-radius:6px;padding:5px 10px;margin-bottom:5px;font-size:12px;font-weight:700}
.totals{margin-top:14px;border-top:1px solid #E5E7EB;padding-top:10px}
.trow{display:flex;justify-content:flex-end;gap:90px;margin-bottom:3px}
.trow .tk{color:#6B7280;font-size:12px}
.trow .tv{font-size:12px;font-weight:600;min-width:100px;text-align:right}
.gt{display:flex;justify-content:flex-end;gap:90px;margin-top:8px;padding-top:8px;border-top:2px solid #1C3FAA}
.gt .tk{font-size:14px;font-weight:700;color:#1C3FAA}
.gt .tv{font-size:16px;font-weight:800;color:#1C3FAA;min-width:100px;text-align:right}
.footer{margin-top:18px;padding-top:12px;border-top:1px solid #E5E7EB;font-size:10px;color:#9CA3AF;line-height:1.7}
</style></head><body>
<button class="print-btn no-print" onclick="window.print()">🖸 Imprimir / Guardar PDF</button>
<div class="hdr">
  <div>
    ${(usuario?.empresa&&usuario.empresa!=='ALQOS™')?`<div class="brand-name">${usuario.empresa}</div>`:''}
    ${usuario?.empresa_direccion||usuario?.direccion?`<div class="brand-sub">${usuario?.empresa_direccion||usuario?.direccion}</div>`:''}
    ${usuario?.empresa_cuit||usuario?.cuit?`<div class="brand-sub">CUIT: ${usuario?.empresa_cuit||usuario?.cuit}</div>`:''}
  </div>
  <div>
    <div class="doc-num">PRESUPUESTO ${cot.codigo||'—'}</div>
    <div class="doc-meta">Fecha: ${cot.fecha||'—'}<br/>V\xE1lido: ${cot.validez_dias||'7'} d\xEDas${cot.fechaVencimiento?` (hasta ${cot.fechaVencimiento})`:''}${cot.vendedor?`<br/>Vendedor: ${cot.vendedor}`:''}</div>
  </div>
</div>
<div class="section">
  <div class="stit">Cliente</div>
  ${cot.cliente?`<div class="fr"><span class="fk">Cliente</span><span class="fv">${cot.cliente}</span></div>`:''}
  ${cot.contacto?`<div class="fr"><span class="fk">Contacto</span><span class="fv">${cot.contacto}</span></div>`:''}
  ${cot.email?`<div class="fr"><span class="fk">Email</span><span class="fv">${cot.email}</span></div>`:''}
  ${cot.telefono?`<div class="fr"><span class="fk">Tel\xE9fono</span><span class="fv">${cot.telefono}</span></div>`:''}
  ${cot.razon_social?`<div class="fr"><span class="fk">Raz\xF3n Social</span><span class="fv">${cot.razon_social}</span></div>`:''}
  ${cot.cuit?`<div class="fr"><span class="fk">CUIT</span><span class="fv">${cot.cuit}</span></div>`:''}
</div>
<div class="section">
  <div class="stit">Detalle</div>
  <table class="it"><thead><tr>
    <th style="width:28px">#</th><th>Descripci\xF3n</th>
    <th style="width:80px;text-align:center">Cantidad</th>
    <th style="width:100px;text-align:right">Precio/u</th>
    <th style="width:110px;text-align:right">Subtotal</th>
  </tr></thead><tbody>${itemsHTML}</tbody></table>
</div>
${termHTML}
${condPago||cot.tiempo_entrega||cot.demasia||cot.sujeto_originales||cot.observaciones?`
<div class="section"><div class="stit">Condiciones</div>
  ${condPago?`<div class="fr"><span class="fk">Condici\xF3n de pago</span><span class="fv">${condPago}${anticipo}</span></div>`:''}
  ${cot.tiempo_entrega?`<div class="fr"><span class="fk">Tiempo de entrega</span><span class="fv">${cot.tiempo_entrega}</span></div>`:''}
  ${cot.demasia?`<div class="dembox"><b>Demas\xEDa:</b> ${cot.demasia}</div>`:''}
  ${cot.sujeto_originales?`<div class="orig">✓ Sujeto a ver originales</div>`:''}
  ${cot.observaciones?`<div class="fr" style="flex-direction:column;gap:2px"><span class="fk">Observaciones</span><span class="fv" style="color:#374151">${cot.observaciones}</span></div>`:''}
</div>`:''}
<div class="totals">
  ${cot.iva?`<div class="trow"><span class="tk">Subtotal</span><span class="tv">$${subtotal.toLocaleString('es-AR')}</span></div>
  <div class="trow"><span class="tk">IVA ${cot.iva_pct||21}%</span><span class="tv">$${iva_monto.toLocaleString('es-AR')}</span></div>`:''}
  <div class="gt"><span class="tk">TOTAL</span><span class="tv">$${total.toLocaleString('es-AR')}</span></div>
</div>
${emissionsHTML}
<div class="footer">Presupuesto v\xE1lido por ${cot.validez_dias||'7'} d\xEDas. Precios en pesos argentinos${cot.iva?`, IVA ${cot.iva_pct||21}% incluido`:''}${cot.po_cliente?`<br/>Ref. PO cliente: ${cot.po_cliente}`:''}</div>
</body></html>`;
    const w = window.open('','_blank','width=920,height=780');
    if (!w) { alert('Habilitá las ventanas emergentes para exportar el PDF.'); return; }
    w.document.write(html);
    w.document.close();
  };
  const exportarPDFInterno = (cot) => {
    const PAGO_LABELS = {
      contado:'Contado','30_dias':'30 días','60_dias':'60 días',
      '90_dias':'90 días',anticipo_saldo:'Anticipo + saldo',a_convenir:'A convenir',
    };
    const subtotal = calcSubtotal(cot.items||[]);
    const iva_monto = cot.iva ? Math.round(subtotal*(Number(cot.iva_pct)||21)/100) : 0;
    const total = cot.iva ? subtotal+iva_monto : subtotal;
    const condPago = PAGO_LABELS[cot.condicion_pago]||cot.condicion_pago||'';
    const anticipo = cot.condicion_pago==='anticipo_saldo'&&cot.anticipo_pct
      ? ` (${cot.anticipo_pct}% anticipo)` : '';
    const itemsHTML = (cot.items||[]).map((item,i) => {
      const subt = (Number(item.cantidad)||0)*(Number(item.precio)||0);
      let desgloseHTML = '';
      if (item.calculadorConfig) {
        const calc = calcEstuche(item.calculadorConfig);
        if (calc.tipo==='rigido' && calc.componentes?.length>0) {
          const compRows = calc.componentes.map(c=>`<tr>
            <td>${c.nombre}</td>
            <td style="text-align:right">${c.dA}\xD7${c.dB} mm</td>
            <td style="text-align:right">${c.bocas}</td>
            <td style="text-align:right">${c.pliegos}</td>
            <td style="text-align:right">${c.peso_kg} kg</td>
            <td style="text-align:right">${c.costo>0?'$'+c.costo.toLocaleString('es-AR'):'-'}</td>
          </tr>`).join('');
          const costosMat = calc.componentes.reduce((s,c)=>s+c.costo,0);
          const costosFijos = Number(item.calculadorConfig.costos_fijos)||0;
          const margenReal = item.margenPct ? Number(item.margenPct) : '';
          desgloseHTML = `<div class="int-wrap">
            <div class="int-tit">Desglose de materiales \xB7 ${calc.tiraje.toLocaleString('es-AR')} u</div>
            <table class="int-tbl"><thead><tr>
              <th>Material</th><th style="text-align:right">Formato</th><th style="text-align:right">Bocas</th><th style="text-align:right">Pliegos</th><th style="text-align:right">Peso kg</th><th style="text-align:right">Costo</th>
            </tr></thead><tbody>${compRows}</tbody></table>
            <div class="int-sum">
              <span>Mat.: $${costosMat.toLocaleString('es-AR')}</span>
              ${costosFijos>0?`<span>Fijos: $${costosFijos.toLocaleString('es-AR')}</span>`:''}
              <span>Costo total: $${calc.costo_total.toLocaleString('es-AR')}</span>
              <span>Precio vta.: $${calc.precio_venta.toLocaleString('es-AR')}</span>
              <span>$/u: $${calc.precio_unitario.toLocaleString('es-AR')}</span>
              ${margenReal!==''?`<span>Margen: ${margenReal}%</span>`:''}
            </div>
          </div>`;
        } else if (calc.rows?.length>0) {
          const scaleRows = calc.rows.map(r=>`<tr>
            <td>${r.tiraje.toLocaleString('es-AR')} u</td>
            <td style="text-align:right">${r.pliegos}</td>
            <td style="text-align:right">${r.kg} kg</td>
            <td style="text-align:right">${r.costo>0?'$'+r.costo.toLocaleString('es-AR'):'-'}</td>
            <td style="text-align:right">${r.precio>0?'$'+r.precio.toLocaleString('es-AR'):'-'}</td>
            <td style="text-align:right">${r.pu>0?'$'+r.pu.toLocaleString('es-AR'):'-'}</td>
          </tr>`).join('');
          desgloseHTML = `<div class="int-wrap">
            <div class="int-tit">Escala de tirajes \xB7 ${calc.dA}\xD7${calc.dB} mm</div>
            <table class="int-tbl"><thead><tr>
              <th>Tiraje</th><th style="text-align:right">Pliegos</th><th style="text-align:right">kg</th><th style="text-align:right">Costo mat.</th><th style="text-align:right">Precio vta.</th><th style="text-align:right">$/u</th>
            </tr></thead><tbody>${scaleRows}</tbody></table>
          </div>`;
        }
      }
      return `<tr>
        <td class="c">${i+1}</td>
        <td class="desc">${item.descripcion||'—'}</td>
        <td class="c">${Number(item.cantidad||0).toLocaleString('es-AR')}</td>
        <td class="r">$${Number(item.precio||0).toLocaleString('es-AR')}</td>
        <td class="r">$${subt.toLocaleString('es-AR')}</td>
      </tr>${desgloseHTML?`<tr><td colspan="5" style="padding:0;background:white">${desgloseHTML}</td></tr>`:''}`;
    }).join('');
    const personalizados = (cot.terminaciones_custom||[]).filter(Boolean);
    const badges = [...(cot.terminaciones||[]), ...personalizados]
      .map(c=>`<span class="tbadge">${TERM_LABEL[c]||c}</span>`).join('');
    const autoCode=[...(cot.terminaciones||[]),...personalizados].map(c=>TERM_LABEL[c]||c).join('+');
    const showTcode=cot.codigo_terminaciones&&cot.codigo_terminaciones!==autoCode;
    const termHTML = (cot.terminaciones?.length>0||personalizados.length>0||cot.codigo_terminaciones) ? `
      <div class="section">
        <div class="stit">Terminaciones</div>
        ${badges?`<div class="tbadges">${badges}</div>`:''}
        ${showTcode?`<div class="tcode">${cot.codigo_terminaciones}</div>`:''}
        ${cot.obs_terminaciones?`<div class="tobs">${cot.obs_terminaciones}</div>`:''}
      </div>` : '';
    const html = `<!DOCTYPE html><html lang="es"><head><meta charset="UTF-8"/>
<title>Presupuesto Interno ${cot.codigo||''}</title>
<style>
*{margin:0;padding:0;box-sizing:border-box}
body{font-family:'Segoe UI',Arial,sans-serif;color:#111;font-size:12px;padding:32px 40px;max-width:860px;margin:0 auto}
@media print{body{padding:10mm 12mm}.no-print{display:none!important}@page{margin:10mm}}
.print-btn{display:inline-block;margin-bottom:20px;padding:8px 18px;background:#374151;color:white;border:none;border-radius:8px;font-size:13px;font-weight:600;cursor:pointer}
.int-badge{display:inline-block;background:#374151;color:white;font-size:10px;font-weight:700;padding:1px 7px;border-radius:4px;margin-left:8px;vertical-align:middle}
.hdr{display:flex;justify-content:space-between;align-items:flex-start;margin-bottom:22px;padding-bottom:14px;border-bottom:2.5px solid #374151}
.brand-name{font-size:22px;font-weight:800;color:#374151;letter-spacing:-.5px}
.brand-sub{font-size:11px;color:#6B7280;margin-top:3px}
.doc-num{font-size:15px;font-weight:700;color:#374151;text-align:right}
.doc-meta{font-size:11px;color:#6B7280;margin-top:4px;line-height:1.7;text-align:right}
.section{margin-bottom:16px}
.stit{font-size:10px;font-weight:700;color:#374151;text-transform:uppercase;letter-spacing:.08em;margin-bottom:6px;padding-bottom:3px;border-bottom:1px solid #E5E7EB}
.fr{display:flex;gap:4px;margin-bottom:3px}
.fk{color:#6B7280;min-width:120px;font-size:12px}
.fv{color:#111;font-weight:500;font-size:12px}
table.it{width:100%;border-collapse:collapse;margin-bottom:4px}
table.it thead th{background:#374151;color:white;padding:7px 10px;text-align:left;font-size:11px;font-weight:600}
table.it tbody td{padding:7px 10px;border-bottom:1px solid #F3F4F6;vertical-align:top}
table.it tbody tr:nth-child(even){background:#F9FAFB}
.c{text-align:center;color:#6B7280}.desc{font-weight:600}.r{text-align:right}
.int-wrap{background:#F8FAFC;border-left:3px solid #374151;padding:10px 14px;margin:2px 10px 6px}
.int-tit{font-size:10px;font-weight:700;color:#374151;text-transform:uppercase;letter-spacing:.05em;margin-bottom:6px}
table.int-tbl{width:100%;border-collapse:collapse;font-size:11px;margin-bottom:8px}
table.int-tbl th{background:#E5E7EB;color:#374151;padding:4px 7px;font-weight:600}
table.int-tbl td{padding:4px 7px;border-bottom:1px solid #F3F4F6}
.int-sum{display:flex;flex-wrap:wrap;gap:12px;font-size:11px;color:#374151;font-weight:600;background:#E5E7EB;padding:6px 10px;border-radius:4px}
.tbadges{display:flex;flex-wrap:wrap;gap:5px;margin-bottom:6px}
.tbadge{background:#374151;color:white;padding:2px 9px;border-radius:20px;font-size:11px;font-weight:700}
.tcode{font-family:monospace;font-weight:700;font-size:13px;color:#374151;background:#F3F4F6;border-radius:6px;padding:6px 10px;margin-bottom:5px}
.tobs{font-size:11px;color:#374151;background:#F9FAFB;border-radius:6px;padding:6px 10px}
.dembox{background:#FFFBEB;border:1px solid #FDE68A;border-radius:6px;padding:7px 10px;margin-bottom:5px;font-size:12px}
.dembox b{color:#854D0E}
.orig{background:#DBEAFE;color:#1D4ED8;border-radius:6px;padding:5px 10px;margin-bottom:5px;font-size:12px;font-weight:700}
.totals{margin-top:14px;border-top:1px solid #E5E7EB;padding-top:10px}
.trow{display:flex;justify-content:flex-end;gap:90px;margin-bottom:3px}
.trow .tk{color:#6B7280;font-size:12px}
.trow .tv{font-size:12px;font-weight:600;min-width:100px;text-align:right}
.gt{display:flex;justify-content:flex-end;gap:90px;margin-top:8px;padding-top:8px;border-top:2px solid #374151}
.gt .tk{font-size:14px;font-weight:700;color:#374151}
.gt .tv{font-size:16px;font-weight:800;color:#374151;min-width:100px;text-align:right}
.footer{margin-top:18px;padding-top:12px;border-top:1px solid #E5E7EB;font-size:10px;color:#9CA3AF;line-height:1.7}
</style></head><body>
<button class="print-btn no-print" onclick="window.print()">🖸 Imprimir / Guardar PDF</button>
<div class="hdr">
  <div>
    ${(usuario?.empresa&&usuario.empresa!=='ALQOS™')?`<div class="brand-name">${usuario.empresa} <span class="int-badge">USO INTERNO</span></div>`:'<div class="brand-name"><span class="int-badge">USO INTERNO</span></div>'}
    ${usuario?.empresa_direccion||usuario?.direccion?`<div class="brand-sub">${usuario?.empresa_direccion||usuario?.direccion}</div>`:''}
    ${usuario?.empresa_cuit||usuario?.cuit?`<div class="brand-sub">CUIT: ${usuario?.empresa_cuit||usuario?.cuit}</div>`:''}
  </div>
  <div>
    <div class="doc-num">PRESUPUESTO ${cot.codigo||'—'}</div>
    <div class="doc-meta">Fecha: ${cot.fecha||'—'}<br/>V\xE1lido: ${cot.validez_dias||'7'} d\xEDas${cot.fechaVencimiento?` (hasta ${cot.fechaVencimiento})`:''}${cot.vendedor?`<br/>Vendedor: ${cot.vendedor}`:''}</div>
  </div>
</div>
<div class="section">
  <div class="stit">Cliente</div>
  ${cot.cliente?`<div class="fr"><span class="fk">Cliente</span><span class="fv">${cot.cliente}</span></div>`:''}
  ${cot.contacto?`<div class="fr"><span class="fk">Contacto</span><span class="fv">${cot.contacto}</span></div>`:''}
  ${cot.email?`<div class="fr"><span class="fk">Email</span><span class="fv">${cot.email}</span></div>`:''}
  ${cot.telefono?`<div class="fr"><span class="fk">Tel\xE9fono</span><span class="fv">${cot.telefono}</span></div>`:''}
  ${cot.razon_social?`<div class="fr"><span class="fk">Raz\xF3n Social</span><span class="fv">${cot.razon_social}</span></div>`:''}
  ${cot.cuit?`<div class="fr"><span class="fk">CUIT</span><span class="fv">${cot.cuit}</span></div>`:''}
</div>
<div class="section">
  <div class="stit">Detalle</div>
  <table class="it"><thead><tr>
    <th style="width:28px">#</th><th>Descripci\xF3n</th>
    <th style="width:80px;text-align:center">Cantidad</th>
    <th style="width:100px;text-align:right">Precio/u</th>
    <th style="width:110px;text-align:right">Subtotal</th>
  </tr></thead><tbody>${itemsHTML}</tbody></table>
</div>
${termHTML}
${condPago||cot.tiempo_entrega||cot.demasia||cot.sujeto_originales||cot.observaciones?`
<div class="section"><div class="stit">Condiciones</div>
  ${condPago?`<div class="fr"><span class="fk">Condici\xF3n de pago</span><span class="fv">${condPago}${anticipo}</span></div>`:''}
  ${cot.tiempo_entrega?`<div class="fr"><span class="fk">Tiempo de entrega</span><span class="fv">${cot.tiempo_entrega}</span></div>`:''}
  ${cot.demasia?`<div class="dembox"><b>Demas\xEDa:</b> ${cot.demasia}</div>`:''}
  ${cot.sujeto_originales?`<div class="orig">✓ Sujeto a ver originales</div>`:''}
  ${cot.observaciones?`<div class="fr" style="flex-direction:column;gap:2px"><span class="fk">Observaciones</span><span class="fv" style="color:#374151">${cot.observaciones}</span></div>`:''}
</div>`:''}
<div class="totals">
  ${cot.iva?`<div class="trow"><span class="tk">Subtotal</span><span class="tv">$${subtotal.toLocaleString('es-AR')}</span></div>
  <div class="trow"><span class="tk">IVA ${cot.iva_pct||21}%</span><span class="tv">$${iva_monto.toLocaleString('es-AR')}</span></div>`:''}
  <div class="gt"><span class="tk">TOTAL</span><span class="tv">$${total.toLocaleString('es-AR')}</span></div>
</div>
<div class="footer">Presupuesto v\xE1lido por ${cot.validez_dias||'7'} d\xEDas. Precios en pesos argentinos${cot.iva?`, IVA ${cot.iva_pct||21}% incluido`:''}${cot.po_cliente?`<br/>Ref. PO cliente: ${cot.po_cliente}`:''}</div>
</body></html>`;
    const w = window.open('','_blank','width=960,height=820');
    if (!w) { alert('Habilitá las ventanas emergentes para exportar el PDF.'); return; }
    w.document.write(html);
    w.document.close();
  };
  const esAdmin = usuario?.rol === 'Administrador';
  useEffect(() => {
    const cargar = async () => {
      await bajarDatos('alqos_cotizaciones');
      try { setCots(JSON.parse(localStorage.getItem('alqos_cotizaciones')||'[]')); } catch { setCots([]); }
      try { setClientes(JSON.parse(localStorage.getItem('alqos_clientes')||'[]')); } catch { setClientes([]); }
      try { setSpecs(JSON.parse(localStorage.getItem('et_specs')||'[]')); } catch { setSpecs([]); }
      try { setCosteos(JSON.parse(localStorage.getItem('alqos_motor_costeo')||'[]')); } catch { setCosteos([]); }
    };
    cargar();
  }, []);
  // Autoguardado: mientras el modal está abierto y estamos editando un
  // registro ya creado (nuevo o existente), cada cambio en el formulario
  // se sincroniza solo, con un pequeño debounce para no saturar Supabase
  // con cada tecla. Así nunca se pierde lo cargado, aunque se cierre la
  // pestaña antes de apretar "Guardar cotización".
  useEffect(() => {
    if (!showForm || !editando || !form.id) return;
    const t = setTimeout(() => {
      const lista = cots.map(c => c.id === form.id
        ? {...c, ...form, subtotal: calcSubtotal(form.items), total: calcTotal(form)}
        : c);
      setCots(lista);
      localStorage.setItem('alqos_cotizaciones', JSON.stringify(lista));
      subirDatos('alqos_cotizaciones');
    }, 1200);
    return () => clearTimeout(t);
  }, [form, showForm, editando]); // eslint-disable-line react-hooks/exhaustive-deps
  const guardarLS = (lista) => { setCots(lista); localStorage.setItem('alqos_cotizaciones', JSON.stringify(lista)); subirDatos('alqos_cotizaciones'); };
  const set = (k,v) => setForm(f=>({...f,[k]:v}));
  // Abre el modal creando de una el registro real (estado "borrador") para
  // que el autoguardado de arriba tenga algo que actualizar desde la
  // primera tecla que se escribe.
  const nuevaCotizacionForm = () => {
    const nueva = {...FORM_VACIO, id:Date.now(), codigo:generarCod(cots), subtotal:0, total:0, historialEstado:[], fechaCreacion:hoy(), creadoPor:usuario?.nombre||'Sistema'};
    guardarLS([nueva,...cots]);
    setForm(nueva);
    setEditando(true);
    setShowForm(true);
    setTabForm('datos');
  };
  const seleccionarCliente = (c) => {
    setForm(f=>({...f, cliente:c.nombre||c.razonSocial||'', clienteId:c.id, contacto:c.contacto||'', email:c.email||'', telefono:c.telefono||''}));
    setShowClienteSelector(false);
  };
  const setItem = (idx,k,v) => setForm(f=>({...f, items:f.items.map((it,i)=>{
    if (i!==idx) return it;
    const actualizado = {...it,[k]:v};
    if ((k==='costoBase'||k==='margenPct') && actualizado.costoBase && actualizado.margenPct) {
      actualizado.precio = String(Math.round(Number(actualizado.costoBase) * (1 + Number(actualizado.margenPct)/100)));
    }
    return actualizado;
  })}));
  const seleccionarET = (idx,spec) => setForm(f=>({...f, items:f.items.map((it,i)=>i===idx?{...it,descripcion:spec.nombre,etSku:spec.sku}:it)}));
  const seleccionarCosteo = (idx,costeo) => setForm(f=>({...f, items:f.items.map((it,i)=>{
    if (i!==idx) return it;
    const costoBase = String(Math.round(costeo.resultado?.total||0));
    const actualizado = {...it, costeoId:costeo.id, costoBase, descripcion: it.descripcion || costeo.nombre};
    if (actualizado.margenPct) {
      actualizado.precio = String(Math.round(Number(costoBase) * (1 + Number(actualizado.margenPct)/100)));
    }
    return actualizado;
  })}));
  const agregarItem = () => setForm(f=>({...f, items:[...f.items,{...ITEM_VACIO}]}));
  const agregarEstuche = () => {
    if (showEstuche) return;
    const newIdx = form.items.length;
    agregarItem();
    setEstucheIdx(newIdx);
    setEstucheForm(ESTUCHE_FORM_INICIAL);
    setShowEstuche(true);
  };
  const eliminarItem = (idx) => setForm(f=>({...f, items:f.items.filter((_,i)=>i!==idx)}));
  // Ya no hace falta rama "nueva" vs "editando": el registro ya existe
  // desde que se abrió el modal (nuevaCotizacionForm) y el autoguardado
  // lo viene actualizando. Este botón solo confirma y cierra prolijo.
  const guardar = () => {
    if (!form.cliente.trim()) return alert('El cliente es obligatorio');
    const lista = cots.map(c=>c.id===form.id?{...c,...form,subtotal:calcSubtotal(form.items),total:calcTotal(form)}:c);
    guardarLS(lista);
    setSeleccionada(lista.find(c=>c.id===form.id));
    setShowForm(false); setEditando(false); setForm(FORM_VACIO); setTabForm('datos');
    setToast('✓ Cotización guardada');
    setTimeout(()=>setToast(''),2000);
  };
  const cambiarEstado = (id, nuevoEstado) => {
    const entrada = {estado:nuevoEstado, fecha:hoy(), usuario:usuario?.nombre};
    const lista = cots.map(c=>c.id===id?{...c,estado:nuevoEstado,historialEstado:[...(c.historialEstado||[]),entrada]}:c);
    guardarLS(lista);
    if (seleccionada?.id===id) setSeleccionada(lista.find(c=>c.id===id));
  };
  const eliminar = (id) => { guardarLS(cots.filter(c=>c.id!==id)); eliminarDato('alqos_cotizaciones', id); setSeleccionada(null); setConfirmEliminar(null); };
  const crearVersion = () => {
    const nueva = {...seleccionada, id:Date.now(), codigo:`${seleccionada.codigo.split('-v')[0]}-v${(seleccionada.version||1)+1}`, version:(seleccionada.version||1)+1, estado:'borrador', historialEstado:[], fechaCreacion:hoy(), creadoPor:usuario?.nombre};
    guardarLS([nueva,...cots]);
    setSeleccionada(nueva);
  };
  const crearOT = () => {
    const ots = JSON.parse(localStorage.getItem('alqos_ots')||'[]');
    const trabajo = seleccionada.items.map(i=>i.descripcion).join(', ');
    const pliegosTecnicos = (seleccionada.items||[])
      .filter(it => it.calculadorConfig?.pliegos)
      .map(it => ({
        itemDescripcion: it.descripcion || '',
        pliegos: it.calculadorConfig.pliegos
          .filter(p => p.activo)
          .map(p => ({
            nombre: p.nombre,
            material: p.material,
            bocas: p.bocas,
            valor: p.valor === 'personalizado' ? p.valor_custom : p.valor,
            unidades: p.unidades || '1',
          })),
      }));
    const nueva = {
      id:Date.now(), op:generarOP(ots), cliente:seleccionada.cliente, trabajo,
      cotizacionId:seleccionada.id, cotizacionCod:seleccionada.codigo, cotizacionRef:seleccionada.codigo,
      pliegosTecnicos,
      estado:'pendiente', fecha:hoy(), fechaCreacion:new Date().toISOString(), creadoPor:usuario?.nombre
    };
    localStorage.setItem('alqos_ots', JSON.stringify([nueva,...ots]));
    subirDatos('alqos_ots');
    alert(`✅ OT ${nueva.op} creada`);
  };
  const consultarARIACompensacion = async (kg, tCO2) => {
    setCargandoCompensacion(true);
    try {
      const prompt = `Sos ARIA, experto en sustentabilidad para industria gráfica de packaging argentina. Para un trabajo que utiliza ${kg.toFixed(2)} kg de papel/cartón y genera ${tCO2.toFixed(4)} tCO₂eq, respondé con EXACTAMENTE este JSON, sin markdown, sin texto antes ni después:\n{"internas":[{"titulo":"","descripcion":"","proveedor":"","costo_estimado":"","reduccion_tco2":0},{"titulo":"","descripcion":"","proveedor":"","costo_estimado":"","reduccion_tco2":0},{"titulo":"","descripcion":"","proveedor":"","costo_estimado":"","reduccion_tco2":0}],"externas":[{"titulo":"","descripcion":"","proveedor":"","costo_estimado":"","reduccion_tco2":0},{"titulo":"","descripcion":"","proveedor":"","costo_estimado":"","reduccion_tco2":0},{"titulo":"","descripcion":"","proveedor":"","costo_estimado":"","reduccion_tco2":0}]}\n\nINTERNAS (3 acciones dentro de la pyme): mejoras de eficiencia energética, optimización de merma de papel, reciclado de recortes, cambio de tintas base agua o UV, paneles solares, reducción de planchas CTP. Campo proveedor: equipo o proveedor recomendado. Campo costo_estimado: inversión estimada en ARS o USD.\n\nEXTERNAS (3 opciones de compensación): programas de bonos de carbono, forestación certificada, programas estatales argentinos disponibles. Campo proveedor: nombre del programa o entidad. Campo costo_estimado: costo por tCO₂eq compensada.`;
      const response = await fetch('/api/aria', {
        method: 'POST',
        headers: { ...(await authHeader()), 'Content-Type': 'application/json' },
        body: JSON.stringify({ model: 'claude-sonnet-4-6', max_tokens: 1200, messages: [{ role: 'user', content: prompt }] }),
      });
      const data = await response.json();
      const raw = data.content?.[0]?.text || '';
      const sugerencias = JSON.parse(raw.replace(/```json/g, '').replace(/```/g, '').trim());
      setForm(f => ({ ...f, sugerencias_compensacion: sugerencias }));
    } catch (e) {
      console.error(e);
      alert('Error al consultar a ARIA para compensación. Verificá la API key.');
    }
    setCargandoCompensacion(false);
  };
  const registrarVenta = () => {
    const ventas = JSON.parse(localStorage.getItem('alqos_ventas')||'[]');
    const ventaExistente = ventas.find(v=>v.cotizacionId===seleccionada.id);
    if (ventaExistente) {
      const entrada = {estado:'aprobada', fecha:hoy(), usuario:usuario?.nombre};
      const actualizadas = ventas.map(v=>v.id===ventaExistente.id
        ?{...v, estado:'aprobada', monto:seleccionada.total, historialEstado:[...(v.historialEstado||[]),entrada]}
        :v);
      localStorage.setItem('alqos_ventas', JSON.stringify(actualizadas));
      subirDatos('alqos_ventas');
      alert(`✅ Venta ${ventaExistente.codigo} actualizada a Aprobada`);
      return;
    }
    const nueva = {
      id:Date.now(),
      codigo:`VTA-${new Date().getFullYear()}-${String(ventas.length+1).padStart(4,'0')}`,
      cliente:seleccionada.cliente, contacto:seleccionada.contacto||'', email:seleccionada.email||'',
      monto:seleccionada.total, producto:seleccionada.items.map(i=>i.descripcion).join(', '),
      cotizacionId:seleccionada.id, cotizacionCod:seleccionada.codigo,
      canal:'Cotización', estado:'aprobada', fecha:hoy(), fechaCreacion:hoy(),
      historialEstado:[{estado:'aprobada',fecha:hoy(),usuario:usuario?.nombre}],
      creadoPor:usuario?.nombre
    };
    localStorage.setItem('alqos_ventas', JSON.stringify([nueva,...ventas]));
    subirDatos('alqos_ventas');
    alert(`✅ Venta registrada por $${Number(seleccionada.total).toLocaleString('es-AR')}`);
  };
  const filtradas = cots.filter(c=>{
    const matchEstado = filtroEstado==='todos'||c.estado===filtroEstado;
    const matchBusq = !busqueda||c.cliente?.toLowerCase().includes(busqueda.toLowerCase())||c.codigo?.toLowerCase().includes(busqueda.toLowerCase());
    return matchEstado&&matchBusq;
  });
  const montoAprobado = cots.filter(c=>c.estado==='aprobada').reduce((a,c)=>a+Number(c.total||0),0);
  const porVencer = cots.filter(c=>c.estado==='enviada'&&diasHasta(c.fechaVencimiento)<=7&&diasHasta(c.fechaVencimiento)>=0).length;
  const inp = {width:'100%',padding:'8px 10px',borderRadius:'8px',border:'1px solid #E5E7EB',fontSize:'13px',boxSizing:'border-box',fontFamily:'Inter, sans-serif'};
  const lbl = {fontSize:'11px',fontWeight:'600',color:'#6B7280',marginBottom:'4px',display:'block'};
  const secTit = {fontSize:'11px',fontWeight:'700',color:'#1C3FAA',margin:'14px 0 8px',paddingBottom:'5px',borderBottom:'1px solid #E8E9F6',textTransform:'uppercase',letterSpacing:'0.08em'};
  const Campo = ({k,v}) => v ? (
    <div style={{display:'flex',justifyContent:'space-between',fontSize:'12px',marginBottom:'6px',paddingBottom:'6px',borderBottom:'1px solid #F9FAFB'}}>
      <span style={{color:'#6B7280'}}>{k}</span>
      <span style={{color:'#111827',fontWeight:'500',textAlign:'right',maxWidth:'60%'}}>{v}</span>
    </div>
  ) : null;
  return (
    <div style={{padding:'24px',fontFamily:'Inter, sans-serif',background:'#E8E9F6',minHeight:'100vh'}}>
      <div style={{display:'flex',alignItems:'center',justifyContent:'space-between',marginBottom:'20px'}}>
        <div>
          <div style={{display:'flex',alignItems:'center',gap:'10px'}}>
            <button onClick={onVolver} style={{background:'none',border:'1px solid #E5E7EB',borderRadius:'8px',padding:'6px 12px',fontSize:'12px',cursor:'pointer',color:'#6B7280'}}>← Menú</button>
          <BotonInstructivo moduloKey="cotizacion" oscuro={oscuro} />
            <span style={{fontSize:'22px'}}>💰</span>
            <h1 style={{fontSize:'20px',fontWeight:'700',color:'#1C3FAA',margin:0}}>Cotizaciones</h1>
            {usuario?.rol === "Administrador" && <BotonMapaProceso moduloKey="cotizacion" oscuro={oscuro} />}
          </div>
          <p style={{fontSize:'12px',color:'#6B7280',marginTop:'4px',marginLeft:'32px'}}>Vinculado con Clientes · ET · OT · Ventas</p>
        </div>
        <button onClick={nuevaCotizacionForm}
          style={{background:'#1C3FAA',color:'white',border:'none',borderRadius:'10px',padding:'10px 18px',fontSize:'13px',fontWeight:'600',cursor:'pointer'}}>+ Nueva cotización</button>
      </div>
      <div style={{display:'grid',gridTemplateColumns:'repeat(5,1fr)',gap:'10px',marginBottom:'20px'}}>
        {[
          {label:'Total',valor:cots.length,color:'#1C3FAA'},
          {label:'Aprobadas',valor:cots.filter(c=>c.estado==='aprobada').length,color:'#16a34a'},
          {label:'Enviadas',valor:cots.filter(c=>c.estado==='enviada').length,color:'#2A7FFF'},
          {label:'Por vencer',valor:porVencer,color:'#d97706'},
          {label:'Monto aprobado',valor:`$${montoAprobado.toLocaleString('es-AR')}`,color:'#16a34a'},
        ].map((m,i)=>(
          <div key={i} style={{background:'white',borderRadius:'12px',padding:'12px 14px',border:'1px solid #E5E7EB'}}>
            <div style={{fontSize:'11px',color:'#6B7280',marginBottom:'4px'}}>{m.label}</div>
            <div style={{fontSize:i===4?'14px':'24px',fontWeight:'700',color:m.color}}>{m.valor}</div>
          </div>
        ))}
      </div>
      <div style={{display:'flex',gap:'10px',marginBottom:'14px',alignItems:'center',flexWrap:'wrap'}}>
        <input placeholder="🔍 Buscar por cliente o código..." value={busqueda} onChange={e=>setBusqueda(e.target.value)}
          style={{...inp,width:'260px',margin:0}}/>
        <div style={{display:'flex',gap:'4px',background:'white',padding:'4px',borderRadius:'10px',border:'1px solid #E5E7EB'}}>
          {['todos',...Object.keys(ESTADOS)].map(k=>(
            <button key={k} onClick={()=>setFiltroEstado(k)}
              style={{padding:'5px 12px',borderRadius:'7px',border:'none',fontSize:'11px',fontWeight:'500',cursor:'pointer',background:filtroEstado===k?'#1C3FAA':'transparent',color:filtroEstado===k?'white':'#6B7280'}}>
              {k==='todos'?'Todas':ESTADOS[k]?.label}
            </button>
          ))}
        </div>
      </div>
      <div style={{display:'grid',gridTemplateColumns:seleccionada?'1fr 420px':'1fr',gap:'14px'}}>
        <div style={{background:'white',borderRadius:'14px',border:'1px solid #E5E7EB',overflow:'hidden'}}>
          {filtradas.length===0?(
            <div style={{padding:'60px',textAlign:'center',color:'#9CA3AF'}}>
              <div style={{fontSize:'40px',marginBottom:'12px'}}>💰</div>
              <div style={{fontSize:'14px',fontWeight:'600'}}>Sin cotizaciones</div>
              <div style={{fontSize:'12px',marginTop:'4px'}}>Creá la primera con el botón de arriba</div>
            </div>
          ):(
            <table style={{width:'100%',borderCollapse:'collapse'}}>
              <thead>
                <tr style={{background:'#F9FAFB'}}>
                  {['Código','Cliente','Ítems','Total','Vencimiento','Estado'].map(h=>(
                    <th key={h} style={{padding:'10px 14px',fontSize:'11px',fontWeight:'600',color:'#6B7280',textAlign:'left',borderBottom:'1px solid #E5E7EB'}}>{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {filtradas.map(c=>{
                  const est=ESTADOS[c.estado]||ESTADOS.borrador;
                  const dias=diasHasta(c.fechaVencimiento);
                  const alerta=c.estado==='enviada'&&dias<=7&&dias>=0;
                  return(
                    <tr key={c.id} onClick={()=>{setSeleccionada(c);setTabDetalle('datos');}}
                      style={{cursor:'pointer',background:seleccionada?.id===c.id?'#EFF6FF':'white'}}
                      onMouseEnter={e=>{if(seleccionada?.id!==c.id)e.currentTarget.style.background='#F9FAFB';}}
                      onMouseLeave={e=>{e.currentTarget.style.background=seleccionada?.id===c.id?'#EFF6FF':'white';}}>
                      <td style={{padding:'11px 14px',borderBottom:'1px solid #F3F4F6'}}>
                        <div style={{fontWeight:'600',fontSize:'12px',color:'#1C3FAA'}}>{c.codigo}</div>
                        {c.version>1&&<div style={{fontSize:'10px',color:'#6B6FD6'}}>v{c.version}</div>}
                      </td>
                      <td style={{padding:'11px 14px',borderBottom:'1px solid #F3F4F6'}}>
                        <div style={{fontWeight:'600',fontSize:'13px',color:'#111827'}}>{c.cliente}</div>
                        <div style={{fontSize:'11px',color:'#9CA3AF'}}>{c.vendedor||'—'}</div>
                      </td>
                      <td style={{padding:'11px 14px',fontSize:'12px',color:'#374151',borderBottom:'1px solid #F3F4F6'}}>{c.items?.length||0} ítems</td>
                      <td style={{padding:'11px 14px',borderBottom:'1px solid #F3F4F6'}}>
                        <div style={{fontWeight:'700',fontSize:'13px',color:'#111827'}}>${Number(c.total||0).toLocaleString('es-AR')}</div>
                      </td>
                      <td style={{padding:'11px 14px',borderBottom:'1px solid #F3F4F6'}}>
                        {alerta
                          ?<span style={{background:'#fef3c7',color:'#d97706',fontSize:'11px',padding:'2px 8px',borderRadius:'6px',fontWeight:'600'}}>⚠ {dias}d</span>
                          :<span style={{fontSize:'12px',color:'#6B7280'}}>{c.fechaVencimiento}</span>}
                      </td>
                      <td style={{padding:'11px 14px',borderBottom:'1px solid #F3F4F6'}}>
                        <span style={{background:est.bg,color:est.color,fontSize:'11px',padding:'3px 9px',borderRadius:'20px',fontWeight:'600'}}>{est.label}</span>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          )}
        </div>
        {seleccionada&&(
          <div style={{background:'white',borderRadius:'14px',border:'1px solid #E5E7EB',overflow:'hidden',maxHeight:'82vh',overflowY:'auto'}}>
            <div style={{padding:'14px 16px',borderBottom:'1px solid #F3F4F6',display:'flex',justifyContent:'space-between',alignItems:'flex-start'}}>
              <div>
                <div style={{fontSize:'12px',color:'#1C3FAA',fontWeight:'600'}}>{seleccionada.codigo}{seleccionada.version>1?` · v${seleccionada.version}`:''}</div>
                <div style={{fontWeight:'700',fontSize:'15px',color:'#111827'}}>{seleccionada.cliente}</div>
                <div style={{marginTop:'6px',display:'flex',gap:'5px',flexWrap:'wrap'}}>
                  <span style={{background:ESTADOS[seleccionada.estado]?.bg,color:ESTADOS[seleccionada.estado]?.color,fontSize:'11px',padding:'2px 9px',borderRadius:'20px',fontWeight:'600'}}>{ESTADOS[seleccionada.estado]?.label}</span>
                  <span style={{background:'#F3F4F6',color:'#374151',fontSize:'11px',padding:'2px 8px',borderRadius:'6px',fontWeight:'700'}}>${Number(seleccionada.total||0).toLocaleString('es-AR')}</span>
                </div>
              </div>
              <div style={{display:'flex',gap:'5px'}}>
                <button onClick={()=>{setForm({...FORM_VACIO,...seleccionada});setEditando(true);setShowForm(true);setTabForm('datos');}}
                  style={{background:'#1C3FAA',color:'white',border:'none',borderRadius:'8px',padding:'6px 10px',fontSize:'11px',fontWeight:'600',cursor:'pointer'}}>✏️ Editar</button>
                <button onClick={()=>exportarPDF(seleccionada)}
                  style={{background:'#F0FDF4',color:'#16a34a',border:'1px solid #bbf7d0',borderRadius:'8px',padding:'6px 10px',fontSize:'11px',fontWeight:'600',cursor:'pointer'}}>📄 PDF</button>
                <button onClick={()=>exportarPDFInterno(seleccionada)}
                  style={{background:'#F3F4F6',color:'#374151',border:'1px solid #D1D5DB',borderRadius:'8px',padding:'6px 10px',fontSize:'11px',fontWeight:'600',cursor:'pointer'}}>🔧 PDF Interno</button>
                {esAdmin&&<button onClick={()=>setConfirmEliminar(seleccionada.id)}
                  style={{background:'#fee2e2',color:'#dc2626',border:'none',borderRadius:'8px',padding:'6px 10px',fontSize:'11px',fontWeight:'600',cursor:'pointer'}}>🗑</button>}
                <button onClick={()=>setSeleccionada(null)} style={{background:'none',border:'none',fontSize:'18px',cursor:'pointer',color:'#9CA3AF'}}>✕</button>
              </div>
            </div>
            <div style={{display:'flex',gap:'2px',padding:'8px 12px',borderBottom:'1px solid #F3F4F6',background:'#F9FAFB'}}>
              {[['datos','📋 Datos'],['items','📦 Ítems'],['estado','🔄 Estado'],['acciones','⚡ Acciones']].map(([id,lb])=>(
                <button key={id} onClick={()=>setTabDetalle(id)}
                  style={{padding:'5px 10px',borderRadius:'7px',border:'none',fontSize:'11px',fontWeight:'500',cursor:'pointer',background:tabDetalle===id?'#1C3FAA':'transparent',color:tabDetalle===id?'white':'#6B7280'}}>{lb}</button>
              ))}
            </div>
            <div style={{padding:'14px 16px'}}>
              {tabDetalle==='datos'&&(<>
                <div style={secTit}>Cliente</div>
                <Campo k="Cliente" v={seleccionada.cliente}/>
                <Campo k="Razón Social" v={seleccionada.razon_social}/>
                <Campo k="CUIT" v={seleccionada.cuit}/>
                <Campo k="N° PO" v={seleccionada.po_cliente}/>
                <Campo k="Contacto" v={seleccionada.contacto}/>
                <Campo k="Email" v={seleccionada.email}/>
                <Campo k="Teléfono" v={seleccionada.telefono}/>
                <div style={secTit}>Cotización</div>
                <Campo k="Vendedor" v={seleccionada.vendedor}/>
                <Campo k="Fecha" v={seleccionada.fecha}/>
                <Campo k="Vencimiento" v={seleccionada.fechaVencimiento}/>
                <Campo k="Creado por" v={seleccionada.creadoPor}/>
                {seleccionada.condicion_pago&&<Campo k="Condición de pago" v={({'contado':'Contado','30_dias':'30 días','60_dias':'60 días','90_dias':'90 días','anticipo_saldo':'Anticipo + saldo','a_convenir':'A convenir'})[seleccionada.condicion_pago]||seleccionada.condicion_pago}/>}
                {seleccionada.condicion_pago==='anticipo_saldo'&&seleccionada.anticipo_pct&&<Campo k="% Anticipo" v={`${seleccionada.anticipo_pct}%`}/>}
                {seleccionada.observaciones&&(
                  <div style={{marginTop:'10px',background:'#F9FAFB',borderRadius:'8px',padding:'10px',fontSize:'12px',color:'#374151'}}>
                    <div style={{fontWeight:'600',fontSize:'11px',color:'#6B7280',marginBottom:'4px'}}>Observaciones</div>
                    {seleccionada.observaciones}
                  </div>
                )}
                {(seleccionada.demasia||seleccionada.tiempo_entrega||seleccionada.validez_dias||seleccionada.sujeto_originales)&&(<>
                  <div style={secTit}>Condiciones</div>
                  <Campo k="Validez" v={seleccionada.validez_dias?`${seleccionada.validez_dias} días`:undefined}/>
                  <Campo k="Tiempo de entrega" v={seleccionada.tiempo_entrega}/>
                  {seleccionada.demasia&&(
                    <div style={{fontSize:'12px',color:'#374151',background:'#FEF9C3',border:'1px solid #FDE68A',borderRadius:'8px',padding:'8px 10px',marginBottom:'6px'}}>
                      <span style={{fontWeight:'600',color:'#854D0E'}}>Demasía: </span>{seleccionada.demasia}
                    </div>
                  )}
                  {seleccionada.sujeto_originales&&(
                    <div style={{fontSize:'12px',color:'#1d4ed8',background:'#dbeafe',borderRadius:'8px',padding:'6px 10px',marginBottom:'6px',fontWeight:'600'}}>
                      ✓ Sujeto a ver originales
                    </div>
                  )}
                </>)}
                {(seleccionada.terminaciones?.length>0||(seleccionada.terminaciones_custom||[]).some(Boolean)||seleccionada.codigo_terminaciones)&&(<>
                  <div style={secTit}>Terminaciones</div>
                  {(seleccionada.terminaciones?.length>0||(seleccionada.terminaciones_custom||[]).some(Boolean))&&(
                    <div style={{display:'flex',flexWrap:'wrap',gap:'5px',marginBottom:'8px'}}>
                      {[...(seleccionada.terminaciones||[]),...(seleccionada.terminaciones_custom||[]).filter(Boolean)].map((code,i)=>(
                        <span key={code+i} style={{background:'#2A7FFF',color:'white',padding:'3px 10px',borderRadius:'20px',fontSize:'11px',fontWeight:'700'}}>
                          {TERM_LABEL[code]||code}
                        </span>
                      ))}
                    </div>
                  )}
                  {seleccionada.codigo_terminaciones&&(
                    <div style={{fontFamily:'monospace',fontWeight:'700',fontSize:'13px',color:'#1C3FAA',background:'#EFF6FF',borderRadius:'8px',padding:'8px 12px',marginBottom:'6px'}}>
                      {seleccionada.codigo_terminaciones}
                    </div>
                  )}
                  {seleccionada.obs_terminaciones&&(
                    <div style={{fontSize:'12px',color:'#374151',background:'#F9FAFB',borderRadius:'8px',padding:'8px 10px'}}>
                      {seleccionada.obs_terminaciones}
                    </div>
                  )}
                </>)}
                {seleccionada.mostrar_emisiones&&(()=>{
                  const {kg,tCO2}=calcEmisionesItems(seleccionada.items||[]);
                  return (<>
                    <div style={secTit}>Huella de Carbono</div>
                    <div style={{background:'#F0FDF4',border:'1px solid #BBF7D0',borderRadius:'8px',padding:'10px 12px',marginBottom:'8px'}}>
                      <div style={{fontSize:'11px',fontWeight:'700',color:'#16a34a',marginBottom:'2px'}}>🌱 Emisiones estimadas</div>
                      <div style={{fontSize:'15px',fontWeight:'800',color:'#16a34a'}}>{tCO2.toFixed(4)} tCO₂eq</div>
                      <div style={{fontSize:'11px',color:'#9CA3AF',marginTop:'2px'}}>{kg.toFixed(2)} kg papel/cartón × 0.921 kgCO₂eq/kg</div>
                    </div>
                    {seleccionada.mostrar_compensacion&&seleccionada.sugerencias_compensacion?.internas?.length>0&&(<>
                      <div style={{fontSize:'11px',fontWeight:'700',color:'#374151',marginBottom:'6px',marginTop:'8px'}}>🏭 Acciones internas</div>
                      {seleccionada.sugerencias_compensacion.internas.map((s,i)=>(
                        <div key={i} style={{background:'#EFF6FF',border:'1px solid #BFDBFE',borderRadius:'8px',padding:'10px 12px',marginBottom:'6px',fontSize:'12px'}}>
                          <div style={{fontWeight:'700',color:'#1d4ed8',marginBottom:'2px'}}>{s.titulo}</div>
                          <div style={{color:'#374151',marginBottom:'4px'}}>{s.descripcion}</div>
                          {s.proveedor&&<div style={{fontSize:'11px',color:'#6B7280'}}>🔧 {s.proveedor}</div>}
                        </div>
                      ))}
                      <div style={{fontSize:'11px',fontWeight:'700',color:'#374151',marginBottom:'6px',marginTop:'8px'}}>🌿 Compensación externa</div>
                      {(seleccionada.sugerencias_compensacion.externas||[]).map((s,i)=>(
                        <div key={i} style={{background:'#F0FDF4',border:'1px solid #BBF7D0',borderRadius:'8px',padding:'10px 12px',marginBottom:'6px',fontSize:'12px'}}>
                          <div style={{fontWeight:'700',color:'#166534',marginBottom:'2px'}}>{s.titulo}</div>
                          <div style={{color:'#374151',marginBottom:'4px'}}>{s.descripcion}</div>
                          {s.proveedor&&<div style={{fontSize:'11px',color:'#6B7280'}}>📍 {s.proveedor}</div>}
                        </div>
                      ))}
                    </>)}
                  </>);
                })()}
              </>)}
              {tabDetalle==='items'&&(<>
                {(seleccionada.items||[]).map((item,i)=>{
                  const margenReal = item.costoBase && Number(item.precio)>0
                    ? Math.round(((Number(item.precio)-Number(item.costoBase))/Number(item.precio))*100)
                    : null;
                  return (
                  <div key={i} style={{background:'#F9FAFB',borderRadius:'10px',padding:'10px 12px',marginBottom:'8px',border:'1px solid #E5E7EB'}}>
                    <div style={{display:'flex',justifyContent:'space-between',marginBottom:'4px'}}>
                      <span style={{fontSize:'12px',fontWeight:'600',color:'#374151'}}>{item.descripcion||`Ítem ${i+1}`}</span>
                      <span style={{fontSize:'13px',fontWeight:'700',color:'#1C3FAA'}}>${((Number(item.cantidad)||0)*(Number(item.precio)||0)).toLocaleString('es-AR')}</span>
                    </div>
                    <div style={{display:'flex',gap:'12px',fontSize:'11px',color:'#6B7280',flexWrap:'wrap'}}>
                      <span>Cant: {item.cantidad}</span>
                      <span>Precio: ${Number(item.precio||0).toLocaleString('es-AR')}</span>
                      {item.etSku&&<span style={{background:'#E8E9F6',color:'#1C3FAA',padding:'1px 6px',borderRadius:'4px',fontWeight:'600'}}>ET: {item.etSku}</span>}
                      {item.costoBase&&<span style={{background:'#F3F4F6',color:'#374151',padding:'1px 6px',borderRadius:'4px',fontWeight:'600'}}>🧮 Costo: ${Number(item.costoBase).toLocaleString('es-AR')}</span>}
                      {margenReal!==null&&<span style={{background:margenReal>=0?'#dcfce7':'#fee2e2',color:margenReal>=0?'#16a34a':'#dc2626',padding:'1px 6px',borderRadius:'4px',fontWeight:'600'}}>Margen real: {margenReal}%</span>}
                    </div>
                  </div>
                  );
                })}
                <div style={{padding:'12px',background:'#1C3FAA',borderRadius:'10px',marginTop:'8px'}}>
                  {seleccionada.iva&&<div style={{display:'flex',justifyContent:'space-between',marginBottom:'4px'}}>
                    <span style={{color:'rgba(255,255,255,0.7)',fontSize:'12px'}}>Subtotal</span>
                    <span style={{color:'rgba(255,255,255,0.7)',fontSize:'12px'}}>${Number(seleccionada.subtotal||seleccionada.total||0).toLocaleString('es-AR')}</span>
                  </div>}
                  {seleccionada.iva&&<div style={{display:'flex',justifyContent:'space-between',marginBottom:'4px'}}>
                    <span style={{color:'rgba(255,255,255,0.7)',fontSize:'12px'}}>IVA {seleccionada.iva_pct||21}%</span>
                    <span style={{color:'rgba(255,255,255,0.7)',fontSize:'12px'}}>${Math.round((seleccionada.subtotal||0)*(seleccionada.iva_pct||21)/100).toLocaleString('es-AR')}</span>
                  </div>}
                  <div style={{display:'flex',justifyContent:'space-between'}}>
                    <span style={{color:'white',fontWeight:'600',fontSize:'13px'}}>TOTAL</span>
                    <span style={{color:'white',fontWeight:'700',fontSize:'15px'}}>${Number(seleccionada.total||0).toLocaleString('es-AR')}</span>
                  </div>
                </div>
              </>)}
              {tabDetalle==='estado'&&(<>
                <div style={secTit}>Cambiar estado</div>
                <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:'8px',marginBottom:'16px'}}>
                  {Object.entries(ESTADOS).map(([val,{label,color,bg}])=>(
                    <button key={val} onClick={()=>cambiarEstado(seleccionada.id,val)}
                      style={{padding:'10px',borderRadius:'10px',border:`1.5px solid ${seleccionada.estado===val?color:'#E5E7EB'}`,background:seleccionada.estado===val?bg:'white',color:seleccionada.estado===val?color:'#6B7280',fontSize:'12px',fontWeight:'600',cursor:'pointer'}}>
                      {label}
                    </button>
                  ))}
                </div>
                <div style={secTit}>Historial</div>
                {(seleccionada.historialEstado||[]).length===0
                  ?<div style={{fontSize:'12px',color:'#9CA3AF',textAlign:'center',padding:'20px'}}>Sin cambios registrados</div>
                  :[...(seleccionada.historialEstado||[])].reverse().map((h,i)=>(
                    <div key={i} style={{display:'flex',alignItems:'center',gap:'8px',padding:'7px 0',borderBottom:'1px solid #F3F4F6',fontSize:'12px'}}>
                      <span style={{background:ESTADOS[h.estado]?.bg,color:ESTADOS[h.estado]?.color,padding:'2px 8px',borderRadius:'20px',fontSize:'11px',fontWeight:'600'}}>{ESTADOS[h.estado]?.label}</span>
                      <span style={{color:'#6B7280'}}>{h.fecha} · {h.usuario}</span>
                    </div>
                  ))
                }
              </>)}
              {tabDetalle==='acciones'&&(<>
                <div style={secTit}>Acciones vinculadas</div>
                <div style={{display:'flex',flexDirection:'column',gap:'8px'}}>
                  <button onClick={crearVersion}
                    style={{padding:'12px',borderRadius:'10px',border:'1px solid #E5E7EB',background:'white',fontSize:'12px',fontWeight:'600',cursor:'pointer',textAlign:'left',color:'#374151'}}>
                    <div style={{fontWeight:'700',marginBottom:'2px'}}>📄 Nueva versión</div>
                    <div style={{fontSize:'11px',color:'#6B7280'}}>Genera v{(seleccionada.version||1)+1} de esta cotización</div>
                  </button>
                  <button onClick={crearOT}
                    style={{padding:'12px',borderRadius:'10px',border:'1px solid #dbeafe',background:'#EFF6FF',fontSize:'12px',fontWeight:'600',cursor:'pointer',textAlign:'left',color:'#1C3FAA'}}>
                    <div style={{fontWeight:'700',marginBottom:'2px'}}>📋 Crear OT desde esta cotización</div>
                    <div style={{fontSize:'11px',color:'#6B7280'}}>Genera una Orden de Trabajo pre-cargada</div>
                  </button>
                  {seleccionada.estado==='aprobada'&&(
                    <button onClick={registrarVenta}
                      style={{padding:'12px',borderRadius:'10px',border:'1px solid #dcfce7',background:'#F0FDF4',fontSize:'12px',fontWeight:'600',cursor:'pointer',textAlign:'left',color:'#16a34a'}}>
                      <div style={{fontWeight:'700',marginBottom:'2px'}}>💹 Registrar venta</div>
                      <div style={{fontSize:'11px',color:'#6B7280'}}>Pasa ${Number(seleccionada.total||0).toLocaleString('es-AR')} a módulo Ventas</div>
                    </button>
                  )}
                </div>
              </>)}
            </div>
          </div>
        )}
      </div>
      {showForm&&(
        <div style={{position:'fixed',inset:0,background:'rgba(0,0,0,0.45)',display:'flex',alignItems:'center',justifyContent:'center',zIndex:1000}}>
          <div style={{background:'white',borderRadius:'16px',width:'620px',maxHeight:'92vh',overflowY:'auto',padding:'24px',boxShadow:'0 20px 60px rgba(0,0,0,0.15)'}}>
            <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:'4px'}}>
              <h2 style={{fontSize:'16px',fontWeight:'700',color:'#1C3FAA',margin:0}}>{editando?'✏️ Editar cotización':'💰 Nueva cotización'}</h2>
              <button onClick={cerrarForm} style={{background:'none',border:'none',fontSize:'20px',cursor:'pointer',color:'#9CA3AF'}}>✕</button>
            </div>
            <p style={{fontSize:'12px',color:'#9CA3AF',margin:'0 0 12px'}}>Vinculado con Clientes · ET · OT · Ventas · guardado automático activado</p>
            <div style={{display:'flex',gap:'4px',background:'#F9FAFB',padding:'4px',borderRadius:'10px',marginBottom:'16px'}}>
              {[['datos','📋 Datos'],['extra','📝 Extra'],['items','📦 Ítems']].map(([id,lb])=>(
                <button key={id} onClick={()=>setTabForm(id)}
                  style={{flex:1,padding:'7px',borderRadius:'8px',border:'none',fontSize:'12px',fontWeight:'500',cursor:'pointer',background:tabForm===id?'#1C3FAA':'transparent',color:tabForm===id?'white':'#6B7280'}}>{lb}</button>
              ))}
            </div>
            {tabForm==='datos'&&(
              <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:'12px'}}>
                <div style={{gridColumn:'1/-1'}}>
                  <label style={lbl}>Cliente *</label>
                  <div style={{display:'flex',gap:'8px'}}>
                    <input style={{...inp,flex:1}} placeholder="Nombre del cliente" value={form.cliente} onChange={e=>set('cliente',e.target.value)}/>
                    <button onClick={()=>setShowClienteSelector(s=>!s)}
                      style={{padding:'8px 12px',borderRadius:'8px',border:'1px solid #E5E7EB',background:'#F9FAFB',fontSize:'12px',cursor:'pointer',color:'#1C3FAA',fontWeight:'600',whiteSpace:'nowrap'}}>
                      📋 Desde módulo
                    </button>
                  </div>
                  {showClienteSelector&&clientes.length>0&&(
                    <div style={{background:'white',border:'1px solid #E5E7EB',borderRadius:'10px',marginTop:'6px',maxHeight:'160px',overflowY:'auto',boxShadow:'0 4px 16px rgba(0,0,0,0.1)'}}>
                      {clientes.map(c=>(
                        <div key={c.id} onClick={()=>seleccionarCliente(c)}
                          style={{padding:'10px 14px',cursor:'pointer',fontSize:'12px',borderBottom:'1px solid #F3F4F6'}}
                          onMouseEnter={e=>e.currentTarget.style.background='#F9FAFB'}
                          onMouseLeave={e=>e.currentTarget.style.background='white'}>
                          <div style={{fontWeight:'600'}}>{c.nombre||c.razonSocial}</div>
                          <div style={{fontSize:'11px',color:'#9CA3AF'}}>{c.email}</div>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
                <div style={{gridColumn:'1/-1'}}>
                  <label style={lbl}>Razón Social</label>
                  <input style={inp} placeholder="Razón social legal" value={form.razon_social} onChange={e=>set('razon_social',e.target.value)}/>
                </div>
                <div><label style={lbl}>CUIT</label><input style={inp} placeholder="XX-XXXXXXXX-X" value={form.cuit} onChange={e=>set('cuit',e.target.value)}/></div>
                <div><label style={lbl}>N° PO cliente</label><input style={inp} placeholder="Orden de compra del cliente" value={form.po_cliente} onChange={e=>set('po_cliente',e.target.value)}/></div>
                <div><label style={lbl}>Contacto</label><input style={inp} placeholder="Nombre contacto" value={form.contacto} onChange={e=>set('contacto',e.target.value)}/></div>
                <div><label style={lbl}>Email</label><input style={inp} placeholder="email@cliente.com" value={form.email} onChange={e=>set('email',e.target.value)}/></div>
                <div><label style={lbl}>Vendedor</label><input style={inp} placeholder="Nombre vendedor" value={form.vendedor} onChange={e=>set('vendedor',e.target.value)}/></div>
                <div><label style={lbl}>Fecha</label><input type="date" style={inp} value={form.fecha} onChange={e=>set('fecha',e.target.value)}/></div>
                <div><label style={lbl}>Vencimiento</label><input type="date" style={inp} value={form.fechaVencimiento} onChange={e=>set('fechaVencimiento',e.target.value)}/></div>
              </div>
            )}
            {tabForm==='items'&&(
              <div>
                {form.items.map((item,idx)=>(
                  <div key={idx} style={{background:'#F9FAFB',borderRadius:'10px',padding:'12px',marginBottom:'8px',border:'1px solid #E5E7EB'}}>
                    <div style={{display:'flex',justifyContent:'space-between',marginBottom:'8px'}}>
                      <span style={{fontSize:'11px',fontWeight:'600',color:'#6B7280'}}>Ítem {idx+1}</span>
                      {form.items.length>1&&<button onClick={()=>eliminarItem(idx)} style={{background:'none',border:'none',color:'#dc2626',cursor:'pointer',fontSize:'16px'}}>×</button>}
                    </div>
                    <label style={lbl}>Descripción</label>
                    <div style={{display:'flex',gap:'6px',marginBottom:'8px'}}>
                      <input style={{...inp,flex:1}} placeholder="Descripción del ítem" value={item.descripcion} onChange={e=>setItem(idx,'descripcion',e.target.value)}/>
                      {specs.length>0&&(
                        <select style={{...inp,width:'auto'}} onChange={e=>{const s=specs.find(sp=>sp.id===Number(e.target.value));if(s)seleccionarET(idx,s);}}>
                          <option value="">📌 ET</option>
                          {specs.map(s=><option key={s.id} value={s.id}>{s.nombre}</option>)}
                        </select>
                      )}
                      {costeos.length>0&&(
                        <select style={{...inp,width:'auto'}} onChange={e=>{const c=costeos.find(co=>String(co.id)===e.target.value);if(c)seleccionarCosteo(idx,c);}}>
                          <option value="">🧮 Costeo</option>
                          {costeos.map(c=><option key={c.id} value={c.id}>{c.nombre}</option>)}
                        </select>
                      )}
                      <button type="button" onClick={()=>{
                        setEstucheIdx(idx);
                        setEstucheForm(item.calculadorConfig ? {...item.calculadorConfig} : ESTUCHE_FORM_INICIAL);
                        setShowEstuche(true);
                      }} style={{padding:'6px 10px',borderRadius:'8px',border:'1px solid #E5E7EB',background:'#F9FAFB',fontSize:'12px',cursor:'pointer',color:'#374151',fontWeight:'600',whiteSpace:'nowrap'}}>
                        📐 Estuche
                      </button>
                    </div>
                    {item.costoBase&&(
                      <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:'8px',marginBottom:'8px'}}>
                        <div><label style={lbl}>Costo base (motor)</label>
                          <div style={{...inp,background:'#F3F4F6',color:'#374151',fontWeight:'600',display:'flex',alignItems:'center'}}>
                            ${Number(item.costoBase).toLocaleString('es-AR')}
                          </div>
                        </div>
                        <div><label style={lbl}>Margen (%)</label><input type="number" style={inp} placeholder="Ej: 35" value={item.margenPct} onChange={e=>setItem(idx,'margenPct',e.target.value)}/></div>
                      </div>
                    )}
                    <div style={{display:'grid',gridTemplateColumns:'1fr 1fr 1fr',gap:'8px'}}>
                      <div><label style={lbl}>Cantidad</label><input type="number" style={inp} placeholder="0" value={item.cantidad} onChange={e=>setItem(idx,'cantidad',e.target.value)}/></div>
                      <div><label style={lbl}>Precio unit.</label><input type="number" style={inp} placeholder="0" value={item.precio} onChange={e=>setItem(idx,'precio',e.target.value)}/></div>
                      <div><label style={lbl}>Subtotal</label>
                        <div style={{...inp,background:'#E8E9F6',color:'#1C3FAA',fontWeight:'700',display:'flex',alignItems:'center'}}>
                          ${((Number(item.cantidad)||0)*(Number(item.precio)||0)).toLocaleString('es-AR')}
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
                <div style={{display:'flex',gap:'8px',marginBottom:'12px'}}>
                  <button onClick={agregarEstuche}
                    style={{flex:2,padding:'11px',borderRadius:'10px',border:'none',background:'#1C3FAA',color:'white',fontSize:'13px',fontWeight:'700',cursor:'pointer'}}>
                    📐 Agregar estuche
                  </button>
                  <button onClick={agregarItem}
                    style={{flex:1,padding:'11px',borderRadius:'10px',border:'1px dashed #C7D2FE',background:'#F5F3FF',color:'#1C3FAA',fontSize:'12px',fontWeight:'600',cursor:'pointer'}}>
                    + Ítem libre
                  </button>
                </div>
                <div style={{padding:'12px',background:'#1C3FAA',borderRadius:'10px'}}>
                  {form.iva&&<div style={{display:'flex',justifyContent:'space-between',marginBottom:'4px'}}>
                    <span style={{color:'rgba(255,255,255,0.7)',fontSize:'12px'}}>Subtotal</span>
                    <span style={{color:'rgba(255,255,255,0.7)',fontSize:'12px'}}>${calcSubtotal(form.items).toLocaleString('es-AR')}</span>
                  </div>}
                  {form.iva&&<div style={{display:'flex',justifyContent:'space-between',marginBottom:'4px'}}>
                    <span style={{color:'rgba(255,255,255,0.7)',fontSize:'12px'}}>IVA {form.iva_pct||21}%</span>
                    <span style={{color:'rgba(255,255,255,0.7)',fontSize:'12px'}}>${Math.round(calcSubtotal(form.items)*(Number(form.iva_pct)||21)/100).toLocaleString('es-AR')}</span>
                  </div>}
                  <div style={{display:'flex',justifyContent:'space-between'}}>
                    <span style={{color:'white',fontWeight:'600'}}>TOTAL</span>
                    <span style={{color:'white',fontWeight:'700',fontSize:'16px'}}>${calcTotal(form).toLocaleString('es-AR')}</span>
                  </div>
                </div>
              </div>
            )}
            {tabForm==='extra'&&(
              <div>
                <label style={lbl}>Estado inicial</label>
                <div style={{display:'flex',gap:'6px',flexWrap:'wrap',marginTop:'4px',marginBottom:'12px'}}>
                  {Object.entries(ESTADOS).map(([val,{label,color,bg}])=>(
                    <button key={val} onClick={()=>set('estado',val)}
                      style={{padding:'6px 12px',borderRadius:'8px',border:`1.5px solid ${form.estado===val?color:'#E5E7EB'}`,background:form.estado===val?bg:'white',color:form.estado===val?color:'#6B7280',fontSize:'12px',fontWeight:'600',cursor:'pointer'}}>{label}</button>
                  ))}
                </div>
                <label style={lbl}>IVA</label>
                <div style={{display:'flex',gap:'8px',alignItems:'center',marginBottom:'12px'}}>
                  <input type="checkbox" checked={!!form.iva} onChange={e=>set('iva',e.target.checked)} id="iva_chk"/>
                  <label htmlFor="iva_chk" style={{fontSize:'12px',color:'#374151'}}>Aplicar IVA</label>
                  {form.iva&&<input type="number" style={{...inp,width:'70px',margin:0}} value={form.iva_pct} onChange={e=>set('iva_pct',e.target.value)}/>}
                  {form.iva&&<span style={{fontSize:'12px',color:'#6B7280'}}>%</span>}
                </div>
                <label style={lbl}>Condición de pago</label>
                <select style={{...inp,marginBottom:'8px'}} value={form.condicion_pago} onChange={e=>set('condicion_pago',e.target.value)}>
                  {[['contado','Contado'],['30_dias','30 días'],['60_dias','60 días'],['90_dias','90 días'],['anticipo_saldo','Anticipo + saldo'],['a_convenir','A convenir']].map(([v,l])=>(
                    <option key={v} value={v}>{l}</option>
                  ))}
                </select>
                {form.condicion_pago==='anticipo_saldo'&&(
                  <div style={{marginBottom:'12px'}}>
                    <label style={lbl}>% Anticipo</label>
                    <input type="number" style={{...inp,width:'100px'}} placeholder="30" value={form.anticipo_pct} onChange={e=>set('anticipo_pct',e.target.value)}/>
                  </div>
                )}
                <div style={{borderTop:'1px solid #F3F4F6',marginTop:'14px',paddingTop:'14px',marginBottom:'12px'}}>
                  <label style={lbl}>Terminaciones</label>
                  <div style={{display:'flex',flexWrap:'wrap',gap:'6px',marginBottom:'10px'}}>
                    {TERMINACIONES_DEF.map(({code,label,desc})=>{
                      const activo=(form.terminaciones||[]).includes(code);
                      const toggleT=()=>setForm(f=>{
                        const ts=activo?(f.terminaciones||[]).filter(c=>c!==code):[...(f.terminaciones||[]),code];
                        const personalizados=(f.terminaciones_custom||[]).filter(Boolean);
                        const autoActual=[...ts,...personalizados].map(c=>TERM_LABEL[c]||c).join('+');
                        const autoAnterior=[...(f.terminaciones||[]),...personalizados].map(c=>TERM_LABEL[c]||c).join('+');
                        const editadoManual=(f.codigo_terminaciones||'')!==autoAnterior;
                        return {...f,terminaciones:ts,...(!editadoManual&&{codigo_terminaciones:autoActual})};
                      });
                      return (
                        <button key={code} type="button" title={desc} onClick={toggleT}
                          style={{padding:'5px 12px',borderRadius:'20px',border:`1.5px solid ${activo?'#2A7FFF':'#E5E7EB'}`,background:activo?'#2A7FFF':'white',color:activo?'white':'#6B7280',fontSize:'12px',fontWeight:'700',cursor:'pointer',letterSpacing:'0.04em'}}>
                          {label}
                        </button>
                      );
                    })}
                  </div>
                  <label style={lbl}>Procesos personalizados (libre — para lo que no está en la lista)</label>
                  <div style={{display:'grid',gridTemplateColumns:'1fr 1fr 1fr',gap:'6px',marginBottom:'10px'}}>
                    {[0,1,2].map(i=>(
                      <input key={i} style={inp} placeholder={`Proceso ${i+1}...`}
                        value={(form.terminaciones_custom||['','',''])[i]}
                        onChange={e=>setForm(f=>{
                          const arr=[...(f.terminaciones_custom||['','',''])];
                          arr[i]=e.target.value;
                          return {...f,terminaciones_custom:arr};
                        })}/>
                    ))}
                  </div>
                  <label style={lbl}>Código de terminaciones</label>
                  <input style={{...inp,marginBottom:'8px',fontFamily:'monospace',fontWeight:'600'}} placeholder="Ej: S+LAM(MATE)+UV" value={form.codigo_terminaciones||''} onChange={e=>set('codigo_terminaciones',e.target.value)}/>
                  <label style={lbl}>Observaciones de terminaciones</label>
                  <input style={inp} placeholder="Notas sobre terminaciones..." value={form.obs_terminaciones||''} onChange={e=>set('obs_terminaciones',e.target.value)}/>
                </div>
                <label style={lbl}>Observaciones</label>
                <textarea style={{...inp,minHeight:'80px',resize:'vertical'}} placeholder="Condiciones, notas..." value={form.observaciones} onChange={e=>set('observaciones',e.target.value)}/>
                <div style={{borderTop:'1px solid #F3F4F6',marginTop:'14px',paddingTop:'14px'}}>
                  <label style={lbl}>Demasía</label>
                  <input style={{...inp,marginBottom:'12px'}} placeholder="+/- 3% por método de producción" value={form.demasia} onChange={e=>set('demasia',e.target.value)}/>
                  <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:'12px',marginBottom:'12px'}}>
                    <div>
                      <label style={lbl}>Validez de la oferta (días)</label>
                      <input type="number" style={inp} placeholder="7" value={form.validez_dias}
                        onChange={e=>{
                          const dias=e.target.value;
                          setForm(f=>({...f,validez_dias:dias,...(dias?{fechaVencimiento:sumarDias(Number(dias))}:{})}));
                        }}/>
                    </div>
                    <div>
                      <label style={lbl}>Tiempo de entrega</label>
                      <input style={inp} placeholder="Ej: 15 días hábiles" value={form.tiempo_entrega} onChange={e=>set('tiempo_entrega',e.target.value)}/>
                    </div>
                  </div>
                  <div style={{display:'flex',gap:'8px',alignItems:'center'}}>
                    <input type="checkbox" id="suj_orig" checked={!!form.sujeto_originales} onChange={e=>set('sujeto_originales',e.target.checked)}/>
                    <label htmlFor="suj_orig" style={{fontSize:'12px',color:'#374151'}}>Sujeto a ver originales</label>
                  </div>
                </div>
                <div style={{borderTop:'1px solid #F3F4F6',marginTop:'14px',paddingTop:'14px'}}>
                  <div style={{fontSize:'11px',fontWeight:'700',color:'#16a34a',marginBottom:'10px',textTransform:'uppercase',letterSpacing:'0.08em'}}>Huella de Carbono</div>
                  <div style={{display:'flex',gap:'8px',alignItems:'center',marginBottom:'8px'}}>
                    <input type="checkbox" id="hc_emisiones" checked={!!form.mostrar_emisiones}
                      onChange={e=>set('mostrar_emisiones',e.target.checked)}/>
                    <label htmlFor="hc_emisiones" style={{fontSize:'12px',color:'#374151'}}>🌱 Mostrar emisiones</label>
                  </div>
                  {form.mostrar_emisiones&&(()=>{
                    const {kg,tCO2}=calcEmisionesItems(form.items);
                    return (<>
                      <div style={{background:'#F0FDF4',border:'1px solid #BBF7D0',borderRadius:'8px',padding:'10px 12px',marginBottom:'10px',fontSize:'12px',color:'#166534'}}>
                        <span style={{fontWeight:'700'}}>Emisiones estimadas: {tCO2.toFixed(4)} tCO₂eq</span>
                        <span style={{color:'#9CA3AF',marginLeft:'8px',fontSize:'11px'}}>({kg.toFixed(2)} kg papel/cartón × 0.921 kgCO₂eq/kg)</span>
                      </div>
                      <div style={{display:'flex',gap:'8px',alignItems:'center',marginBottom:'8px'}}>
                        <input type="checkbox" id="hc_compensacion" checked={!!form.mostrar_compensacion}
                          onChange={e=>{set('mostrar_compensacion',e.target.checked);if(!e.target.checked)set('sugerencias_compensacion',null);}}/>
                        <label htmlFor="hc_compensacion" style={{fontSize:'12px',color:'#374151'}}>♻️ Mostrar compensación</label>
                      </div>
                      {form.mostrar_compensacion&&(
                        <div>
                          {!form.sugerencias_compensacion?.internas?.length&&(
                            <button type="button" onClick={()=>consultarARIACompensacion(kg,tCO2)} disabled={cargandoCompensacion}
                              style={{padding:'7px 14px',background:cargandoCompensacion?'#9CA3AF':'linear-gradient(135deg,#7B5BF2,#09184D)',color:'white',border:'none',borderRadius:'8px',cursor:cargandoCompensacion?'default':'pointer',fontSize:'12px',fontWeight:'600',marginBottom:'8px'}}>
                              {cargandoCompensacion?'🤖 Consultando a ARIA...':'🤖 Consultar opciones a ARIA'}
                            </button>
                          )}
                          {!!form.sugerencias_compensacion?.internas?.length&&(<>
                            <div style={{fontSize:'11px',fontWeight:'700',color:'#374151',marginBottom:'6px'}}>🏭 Acciones internas</div>
                            {form.sugerencias_compensacion.internas.map((s,i)=>(
                              <div key={i} style={{background:'#EFF6FF',border:'1px solid #BFDBFE',borderRadius:'8px',padding:'10px 12px',marginBottom:'6px',fontSize:'12px'}}>
                                <div style={{fontWeight:'700',color:'#1d4ed8',marginBottom:'2px'}}>{s.titulo}</div>
                                <div style={{color:'#374151',marginBottom:'4px'}}>{s.descripcion}</div>
                                <div style={{display:'flex',gap:'12px',color:'#6B7280',fontSize:'11px',flexWrap:'wrap'}}>
                                  {s.proveedor&&<span>🔧 {s.proveedor}</span>}
                                  {s.costo_estimado&&<span>💰 {s.costo_estimado}</span>}
                                  {s.reduccion_tco2>0&&<span>🌱 -{s.reduccion_tco2} tCO₂eq</span>}
                                </div>
                              </div>
                            ))}
                            <div style={{fontSize:'11px',fontWeight:'700',color:'#374151',marginBottom:'6px',marginTop:'10px'}}>🌿 Compensación externa</div>
                            {(form.sugerencias_compensacion.externas||[]).map((s,i)=>(
                              <div key={i} style={{background:'#F0FDF4',border:'1px solid #BBF7D0',borderRadius:'8px',padding:'10px 12px',marginBottom:'6px',fontSize:'12px'}}>
                                <div style={{fontWeight:'700',color:'#166534',marginBottom:'2px'}}>{s.titulo}</div>
                                <div style={{color:'#374151',marginBottom:'4px'}}>{s.descripcion}</div>
                                <div style={{display:'flex',gap:'12px',color:'#6B7280',fontSize:'11px',flexWrap:'wrap'}}>
                                  {s.proveedor&&<span>📍 {s.proveedor}</span>}
                                  {s.costo_estimado&&<span>💰 {s.costo_estimado}</span>}
                                  {s.reduccion_tco2>0&&<span>🌱 -{s.reduccion_tco2} tCO₂eq</span>}
                                </div>
                              </div>
                            ))}
                            <button type="button" onClick={()=>consultarARIACompensacion(kg,tCO2)} disabled={cargandoCompensacion}
                              style={{padding:'5px 12px',background:'white',border:'1px solid #E5E7EB',color:'#6B7280',borderRadius:'6px',cursor:'pointer',fontSize:'11px',marginTop:'4px'}}>
                              🔄 Regenerar
                            </button>
                          </>)}
                        </div>
                      )}
                    </>);
                  })()}
                </div>
              </div>
            )}
            <div style={{display:'flex',gap:'10px',marginTop:'20px'}}>
              <button onClick={cerrarForm}
                style={{flex:1,padding:'10px',borderRadius:'10px',border:'1px solid #E5E7EB',background:'white',fontSize:'13px',fontWeight:'600',cursor:'pointer',color:'#6B7280'}}>Cerrar</button>
              <button onClick={guardar}
                style={{flex:2,padding:'10px',borderRadius:'10px',border:'none',background:'#1C3FAA',color:'white',fontSize:'13px',fontWeight:'600',cursor:'pointer'}}>Guardar cotización</button>
            </div>
          </div>
        </div>
      )}
      {confirmEliminar&&(
        <div style={{position:'fixed',inset:0,background:'rgba(0,0,0,0.45)',display:'flex',alignItems:'center',justifyContent:'center',zIndex:1001}}>
          <div style={{background:'white',borderRadius:'16px',padding:'28px',maxWidth:'340px',width:'90%',textAlign:'center'}}>
            <div style={{fontSize:'36px',marginBottom:'12px'}}>💰</div>
            <div style={{fontSize:'15px',fontWeight:'600',color:'#111827',marginBottom:'8px'}}>¿Eliminar esta cotización?</div>
            <div style={{fontSize:'12px',color:'#6B7280',marginBottom:'20px'}}>Esta acción no se puede deshacer.</div>
            <div style={{display:'flex',gap:'10px'}}>
              <button onClick={()=>setConfirmEliminar(null)} style={{flex:1,padding:'10px',borderRadius:'10px',border:'1px solid #E5E7EB',background:'white',fontSize:'13px',fontWeight:'600',cursor:'pointer',color:'#6B7280'}}>Cancelar</button>
              <button onClick={()=>eliminar(confirmEliminar)} style={{flex:1,padding:'10px',borderRadius:'10px',border:'none',background:'#dc2626',color:'white',fontSize:'13px',fontWeight:'600',cursor:'pointer'}}>Eliminar</button>
            </div>
          </div>
        </div>
      )}
      {showEstuche&&(()=>{
        const setEF=(k,v)=>setEstucheForm(f=>({...f,[k]:v}));
        const setTir=(k,v)=>setEstucheForm(f=>({...f,tirajes:{...f.tirajes,[k]:v}}));
        const res=calcEstuche(estucheForm);
        const esRigido=estucheForm.tipo==='rigido';
        const TIPOS=[['plegadizo','Plegadizo estándar'],['fondo_auto','Fondo automático'],['con_ventana','Con ventana'],['rigido','Caja rígida'],['con_manija','Con manija']];
        const GRAMAJES=['250','300','350','400','500'];
        const inpE={width:'100%',padding:'7px 10px',borderRadius:'8px',border:'1px solid #D1D5DB',fontSize:'12px',boxSizing:'border-box',marginBottom:'10px'};
        const lblE={display:'block',fontSize:'11px',fontWeight:'600',color:'#6B7280',marginBottom:'3px'};
        const transferir=(row)=>{
          const etiqueta=TIPOS.find(t=>t[0]===estucheForm.tipo)?.[1]||'Estuche';
          setForm(f=>{
            const items=[...f.items];
            if (esRigido) {
              const _getV=p=>p?.valor==='personalizado'?p?.valor_custom:p?.valor;
              const _lamT=estucheForm.pliegos.find(p=>p.nombre==='LAM TAPA');
              const _ctT=estucheForm.pliegos.find(p=>p.nombre==='CARTÓN TAPA');
              const desc=`Caja rígida — LAM ${_getV(_lamT)||'?'}g/m² + cartón ${_getV(_ctT)||'?'}mm`;
              const todosLosTirajes=[
                {tiraje:String(estucheForm.tiraje_rigido||''),precio_override:''},
                ...(estucheForm.tirajes_extra||[]),
              ].filter(t=>Number(t.tiraje)>0);
              const baseItem=items[estucheIdx];
              const currentGrupoId=baseItem?.grupoId;
              let insertIdx=estucheIdx, removeCount=1;
              if (currentGrupoId) {
                const gi=items.reduce((acc,it,i)=>it.grupoId===currentGrupoId?[...acc,i]:acc,[]);
                if (gi.length>0) { insertIdx=gi[0]; removeCount=gi.length; }
              }
              const newGrupoId=String(Math.floor(Date.now()));
              const newItems=todosLosTirajes.map(t=>{
                const cr=calcEstuche({...estucheForm,tiraje_rigido:t.tiraje});
                const precioU=t.precio_override?Number(t.precio_override):cr.precio_unitario;
                return {...baseItem,
                  descripcion:desc,
                  cantidad:String(t.tiraje),
                  costoBase:String(Math.round(cr.costo_total/Math.max(1,Number(t.tiraje)))),
                  margenPct:String(estucheForm.margen_estuche),
                  precio:String(precioU),
                  calculadorConfig:{...estucheForm},
                  grupoId:newGrupoId,
                };
              });
              const fallback=[{...baseItem,
                descripcion:desc,cantidad:String(estucheForm.tiraje_rigido||''),
                costoBase:String(Math.round(res.costo_total/Math.max(1,res.tiraje))),
                margenPct:String(estucheForm.margen_estuche),precio:String(res.precio_unitario),
                calculadorConfig:{...estucheForm},grupoId:newGrupoId,
              }];
              items.splice(insertIdx,removeCount,...(newItems.length>0?newItems:fallback));
            } else {
              items[estucheIdx]={...items[estucheIdx],
                descripcion:`${etiqueta} ${row.tiraje}u (${res.dA}×${res.dB}mm, ${estucheForm.gramaje}g)`,
                cantidad:String(row.tiraje),
                costoBase:String(Math.round(row.costo/row.tiraje)),
                margenPct:String(estucheForm.margen_estuche),
                precio:String(row.pu),
                calculadorConfig:{...estucheForm},
              };
            }
            const cleanItems=items.filter(it=>it.descripcion||Number(it.cantidad)||Number(it.precio));
            return {...f,items:cleanItems.length>0?cleanItems:[{...ITEM_VACIO}]};
          });
          setRepeticionRef(null);
          setModoCalc('nuevo');
          setShowEstuche(false);
        };
        return (
          <div style={{position:'fixed',inset:0,background:'rgba(0,0,0,0.6)',zIndex:9999,display:'flex',alignItems:'flex-start',justifyContent:'center',padding:'1rem',overflowY:'auto'}}
            onClick={e=>{if(e.target===e.currentTarget)cerrarEstuche();}}>
            <div style={{background:'white',borderRadius:'16px',padding:'20px',width:'100%',maxWidth:'560px',boxShadow:'0 20px 60px rgba(0,0,0,0.3)',marginTop:'20px'}}>
              <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:'16px'}}>
                <div>
                  <div style={{fontSize:'11px',color:'#2A7FFF',fontWeight:'700',textTransform:'uppercase',letterSpacing:'.08em'}}>📐 Calculador</div>
                  <div style={{fontSize:'16px',fontWeight:'700',color:'#111827'}}>Estuche</div>
                </div>
                <button onClick={cerrarEstuche} style={{background:'none',border:'none',fontSize:'20px',cursor:'pointer',color:'#9CA3AF'}}>✕</button>
              </div>
              {(()=>{
                const itemsConConfig=cots.flatMap(c=>(c.items||[]).filter(it=>it.calculadorConfig).map(it=>({codigoCot:c.codigo,cliente:c.cliente,fecha:c.fecha,desc:it.descripcion,config:it.calculadorConfig})));
                const resultadosBusq=busqRepeticion.trim()===''?itemsConConfig:itemsConConfig.filter(r=>r.cliente?.toLowerCase().includes(busqRepeticion.toLowerCase())||r.desc?.toLowerCase().includes(busqRepeticion.toLowerCase())||r.codigoCot?.toLowerCase().includes(busqRepeticion.toLowerCase()));
                const cargarRepeticion=r=>{setEstucheForm({...r.config});setRepeticionRef({codigo:r.codigoCot,cliente:r.cliente,desc:r.desc});setModoCalc('nuevo');setBusqRepeticion('');};
                return (
                  <div style={{marginBottom:'12px'}}>
                    {repeticionRef?(
                      <div style={{display:'flex',alignItems:'center',justifyContent:'space-between',background:'#f0fdf4',border:'1px solid #bbf7d0',borderRadius:'10px',padding:'8px 12px',fontSize:'12px',color:'#166534'}}>
                        <span><b>📋 {repeticionRef.codigo}</b> · {repeticionRef.cliente}{repeticionRef.desc&&<span style={{color:'#4ade80'}}> — {repeticionRef.desc.slice(0,40)}{repeticionRef.desc.length>40?'…':''}</span>}</span>
                        <button onClick={()=>{setRepeticionRef(null);setModoCalc('nuevo');}} style={{background:'none',border:'none',color:'#166534',cursor:'pointer',fontSize:'16px',fontWeight:'700',lineHeight:1}}>×</button>
                      </div>
                    ):modoCalc==='repeticion'?(
                      <div style={{background:'#F9FAFB',border:'1px solid #E5E7EB',borderRadius:'10px',padding:'10px'}}>
                        <div style={{display:'flex',gap:'6px',marginBottom:'8px'}}>
                          <input autoFocus placeholder="🔍 Buscar cliente o trabajo anterior..." style={{flex:1,padding:'7px 10px',borderRadius:'8px',border:'1px solid #D1D5DB',fontSize:'12px'}} value={busqRepeticion} onChange={e=>setBusqRepeticion(e.target.value)}/>
                          <button onClick={()=>{setModoCalc('nuevo');setBusqRepeticion('');}} style={{padding:'7px 10px',borderRadius:'8px',border:'1px solid #E5E7EB',background:'white',fontSize:'12px',cursor:'pointer',color:'#6B7280'}}>✕</button>
                        </div>
                        <div style={{maxHeight:'160px',overflowY:'auto'}}>
                          {resultadosBusq.length===0?(
                            <div style={{fontSize:'12px',color:'#9CA3AF',padding:'10px',textAlign:'center'}}>{itemsConConfig.length===0?'Todavía no hay trabajos guardados con config del calculador.':'Sin coincidencias.'}</div>
                          ):resultadosBusq.map((r,i)=>(
                            <div key={i} onClick={()=>cargarRepeticion(r)} style={{padding:'8px 10px',borderRadius:'8px',cursor:'pointer',borderBottom:'1px solid #F3F4F6',fontSize:'12px'}} onMouseEnter={e=>e.currentTarget.style.background='#EFF6FF'} onMouseLeave={e=>e.currentTarget.style.background='transparent'}>
                              <div style={{fontWeight:'600',color:'#1C3FAA'}}>{r.codigoCot} · {r.cliente}</div>
                              <div style={{color:'#6B7280',fontSize:'11px'}}>{r.desc} · {r.fecha}</div>
                            </div>
                          ))}
                        </div>
                      </div>
                    ):(
                      <button type="button" onClick={()=>setModoCalc('repeticion')} style={{width:'100%',padding:'8px',borderRadius:'10px',border:'1px dashed #C7D2FE',background:'#F5F3FF',color:'#1C3FAA',fontSize:'12px',fontWeight:'600',cursor:'pointer'}}>📋 Basado en trabajo anterior</button>
                    )}
                  </div>
                );
              })()}
              <div style={{opacity:modoCalc==='repeticion'&&!repeticionRef?0.35:1,pointerEvents:modoCalc==='repeticion'&&!repeticionRef?'none':'auto'}}>
              {!esRigido&&(
                <div style={{display:'flex',gap:'6px',marginBottom:'14px'}}>
                  {[['geo','📐 Geométrico'],['manual','✏️ Manual (A×B)']].map(([v,l])=>(
                    <button key={v} type="button" onClick={()=>setEF('modo',v)}
                      style={{flex:1,padding:'7px',borderRadius:'8px',border:`1.5px solid ${estucheForm.modo===v?'#1C3FAA':'#E5E7EB'}`,background:estucheForm.modo===v?'#EFF6FF':'white',color:estucheForm.modo===v?'#1C3FAA':'#6B7280',fontSize:'12px',fontWeight:'600',cursor:'pointer'}}>
                      {l}
                    </button>
                  ))}
                </div>
              )}
              {(estucheForm.modo==='geo'||esRigido)&&<>
                <label style={lblE}>Tipo</label>
                <div style={{display:'flex',flexWrap:'wrap',gap:'5px',marginBottom:'12px'}}>
                  {TIPOS.map(([v,l])=>(
                    <button key={v} type="button" onClick={()=>setEF('tipo',v)}
                      style={{padding:'5px 10px',borderRadius:'7px',border:`1.5px solid ${estucheForm.tipo===v?'#1C3FAA':'#E5E7EB'}`,background:estucheForm.tipo===v?'#EFF6FF':'white',color:estucheForm.tipo===v?'#1C3FAA':'#6B7280',fontSize:'11px',fontWeight:'600',cursor:'pointer'}}>
                      {l}
                    </button>
                  ))}
                </div>
                <div style={{display:'grid',gridTemplateColumns:'1fr 1fr 1fr',gap:'8px'}}>
                  <div><label style={lblE}>Largo int. (mm)</label><input type="number" style={inpE} placeholder="200" value={estucheForm.largo} onChange={e=>setEF('largo',e.target.value)}/></div>
                  <div><label style={lblE}>Alto int. (mm)</label><input type="number" style={inpE} placeholder="150" value={estucheForm.alto} onChange={e=>setEF('alto',e.target.value)}/></div>
                  <div><label style={lblE}>Profund. (mm)</label><input type="number" style={inpE} placeholder="50" value={estucheForm.prof} onChange={e=>setEF('prof',e.target.value)}/></div>
                </div>
                {!esRigido&&(
                  <div style={{display:'grid',gridTemplateColumns:'1fr 1fr 1fr',gap:'8px'}}>
                    <div><label style={lblE}>Gramaje (g/m²)</label>
                      <select style={inpE} value={estucheForm.gramaje} onChange={e=>setEF('gramaje',e.target.value)}>
                        {GRAMAJES.map(g=><option key={g} value={g}>{g}</option>)}
                      </select>
                    </div>
                    <div><label style={lblE}>Pestaña (mm)</label>
                      <select style={inpE} value={estucheForm.pestaña} onChange={e=>setEF('pestaña',e.target.value)}>
                        <option value="12">12 — Liviana</option>
                        <option value="15">15 — Estándar</option>
                        <option value="20">20 — Pesada</option>
                      </select>
                    </div>
                    <div><label style={lblE}>Sangrado (mm)</label>
                      <select style={inpE} value={estucheForm.sangrado} onChange={e=>setEF('sangrado',e.target.value)}>
                        <option value="3">3 — Estándar</option>
                        <option value="5">5 — Cartón grueso</option>
                      </select>
                    </div>
                  </div>
                )}
                {esRigido&&(()=>{
                  const OPCIONES = {
                    'papel':       ['115','130','150','170','200','240','300','personalizado'],
                    'cartulina':   ['180','200','240','260','295','330','personalizado'],
                    'cartón gris': ['0.8','1.0','1.2','1.5','2.0','2.2','2.5','3.0','personalizado'],
                    'eva':         ['-'],
                  };
                  const MAT_BADGE = {
                    'papel':       {bg:'#dbeafe',color:'#1d4ed8'},
                    'cartón gris': {bg:'#F3F4F6',color:'#374151'},
                    'cartulina':   {bg:'#fef9c3',color:'#854d0e'},
                    'eva':         {bg:'#dcfce7',color:'#166534'},
                  };
                  const OPCIONALES = new Set(['CUNA','GOMA EVA']);
                  const FIJOS = new Set(['LAM TAPA','LAM BASE','CARTÓN TAPA','CARTÓN BASE','CUNA','GOMA EVA']);
                  const setP = (idx,k,v) => setEstucheForm(f=>({...f,pliegos:f.pliegos.map((p,i)=>i===idx?{...p,[k]:v}:p)}));
                  const agregarMat = () => setEstucheForm(f=>({...f,pliegos:[...f.pliegos,{nombre:'',material:'papel',activo:true,bocas:'1',unidades:'1',valor:'personalizado',valor_custom:'',costo:'',merma:'10'}]}));
                  const eliminarMat = idx => setEstucheForm(f=>({...f,pliegos:f.pliegos.filter((_,i)=>i!==idx)}));
                  const inpTd={padding:'3px 5px',borderRadius:'6px',border:'1px solid #D1D5DB',fontSize:'11px',boxSizing:'border-box'};
                  return (
                    <>
                      <div style={{display:'flex',alignItems:'center',gap:'10px',marginBottom:'10px'}}>
                        <label style={{...lblE,margin:0}}>Vuelta LAM (mm)</label>
                        <input type="number" style={{...inpTd,width:'60px'}} placeholder="15" value={estucheForm.vuelta} onChange={e=>setEF('vuelta',e.target.value)}/>
                      </div>
                      <div style={{overflowX:'auto',marginBottom:'8px'}}>
                        <table style={{width:'100%',borderCollapse:'collapse',fontSize:'11px'}}>
                          <thead>
                            <tr style={{background:'#1C3FAA',color:'white'}}>
                              {['Pliego','Material','Bocas','Unid./estuche','Gramaje / Calibre','Merma %','Costo',''].map((h,i)=>(
                                <th key={i} style={{padding:'6px 8px',textAlign:i===0?'left':'center',fontWeight:'600',whiteSpace:'nowrap'}}>{h}</th>
                              ))}
                            </tr>
                          </thead>
                          <tbody>
                            {estucheForm.pliegos.map((p,idx)=>{
                              const esOpcional = OPCIONALES.has(p.nombre);
                              const esFijo = FIJOS.has(p.nombre);
                              const badge = MAT_BADGE[p.material]||{bg:'#F9FAFB',color:'#6B7280'};
                              const opciones = OPCIONES[p.material]||['personalizado'];
                              const opac = (esOpcional||!esFijo) && !p.activo ? 0.4 : 1;
                              return (
                                <tr key={idx} style={{background:idx%2===0?'white':'#F9FAFB',opacity:opac,borderBottom:'1px solid #E5E7EB'}}>
                                  <td style={{padding:'5px 8px',fontWeight:'600',whiteSpace:'nowrap'}}>
                                    {(esOpcional||!esFijo)
                                      ? <label style={{display:'flex',alignItems:'center',gap:'5px',cursor:'pointer'}}>
                                          <input type="checkbox" checked={!!p.activo} onChange={e=>setP(idx,'activo',e.target.checked)}/>
                                          {esFijo ? p.nombre : <input style={{...inpTd,width:'90px'}} value={p.nombre} onChange={e=>setP(idx,'nombre',e.target.value)} placeholder="Material"/>}
                                        </label>
                                      : p.nombre
                                    }
                                  </td>
                                  <td style={{padding:'5px 8px',textAlign:'center'}}>
                                    {esFijo
                                      ? <span style={{background:badge.bg,color:badge.color,padding:'2px 7px',borderRadius:'5px',fontSize:'10px',fontWeight:'600'}}>{p.material}</span>
                                      : <select style={{...inpTd,fontSize:'10px'}} value={p.material} onChange={e=>setP(idx,'material',e.target.value)}>
                                          {Object.keys(OPCIONES).map(m=><option key={m} value={m}>{m}</option>)}
                                        </select>
                                    }
                                  </td>
                                  <td style={{padding:'5px 8px',textAlign:'center'}}>
                                    <div style={{display:'inline-flex',flexDirection:'column',alignItems:'center',gap:'1px'}}>
                                      {!esFijo&&<span style={{fontSize:'9px',color:'#6B7280',fontWeight:'600',lineHeight:1}}>Bocas</span>}
                                      <input type="number" min="1" style={{...inpTd,width:'52px',textAlign:'center'}}
                                        value={p.bocas} onChange={e=>setP(idx,'bocas',e.target.value)}/>
                                    </div>
                                  </td>
                                  <td style={{padding:'5px 8px',textAlign:'center'}}>
                                    {(esFijo && !esOpcional)
                                      ? <span style={{color:'#9CA3AF'}}>—</span>
                                      : <input type="number" min="1" step="1" style={{...inpTd,width:'48px',textAlign:'center'}}
                                          value={p.unidades??'1'} onChange={e=>setP(idx,'unidades',e.target.value)}/>
                                    }
                                  </td>
                                  <td style={{padding:'5px 8px',textAlign:'center'}}>
                                    {p.material==='eva' ? <span style={{color:'#9CA3AF'}}>—</span> : (
                                      <div style={{display:'flex',alignItems:'center',gap:'4px',justifyContent:'center'}}>
                                        <select style={{...inpTd,maxWidth:'110px'}} value={p.valor} onChange={e=>setP(idx,'valor',e.target.value)}>
                                          {opciones.map(o=><option key={o} value={o}>{o==='personalizado'?'personalizado':o+({papel:' g',cartulina:' g','cartón gris':' mm'}[p.material]||'')}</option>)}
                                        </select>
                                        {p.valor==='personalizado'&&(
                                          <input type="number" style={{...inpTd,width:'60px'}} placeholder="valor"
                                            value={p.valor_custom} onChange={e=>setP(idx,'valor_custom',e.target.value)}/>
                                        )}
                                      </div>
                                    )}
                                  </td>
                                  <td style={{padding:'5px 8px',textAlign:'center'}}>
                                    <input type="number" min="0" max="30" style={{...inpTd,width:'48px',textAlign:'center'}}
                                      value={p.merma} onChange={e=>setP(idx,'merma',e.target.value)}/>
                                  </td>
                                  <td style={{padding:'5px 8px',textAlign:'center'}}>
                                    <div style={{display:'inline-flex',flexDirection:'column',alignItems:'flex-end',gap:'1px'}}>
                                      <input type="number" style={{...inpTd,width:'80px',textAlign:'right',marginBottom:0}}
                                        placeholder="0"
                                        value={p.costo} onChange={e=>setP(idx,'costo',e.target.value)}/>
                                      <span style={{fontSize:'9px',color:'#9CA3AF',lineHeight:1}}>{p.material==='eva'?'$/m²':'$/kg'}</span>
                                    </div>
                                  </td>
                                  <td style={{padding:'5px 4px',textAlign:'center'}}>
                                    {!esFijo&&(
                                      <button type="button" onClick={()=>eliminarMat(idx)}
                                        style={{background:'none',border:'none',color:'#dc2626',cursor:'pointer',fontSize:'14px',lineHeight:1}}>×</button>
                                    )}
                                  </td>
                                </tr>
                              );
                            })}
                          </tbody>
                        </table>
                      </div>
                      <button type="button" onClick={agregarMat}
                        style={{width:'100%',padding:'7px',borderRadius:'8px',border:'1px dashed #C7D2FE',background:'#F5F3FF',color:'#1C3FAA',fontSize:'12px',fontWeight:'600',cursor:'pointer',marginBottom:'10px'}}>
                        + Agregar material
                      </button>
                    </>
                  );
                })()}
              </>}
              {estucheForm.modo==='manual'&&!esRigido&&(
                <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:'8px'}}>
                  <div><label style={lblE}>Desenvolvimiento A (mm)</label><input type="number" style={inpE} placeholder="450" value={estucheForm.desenv_manual_a} onChange={e=>setEF('desenv_manual_a',e.target.value)}/></div>
                  <div><label style={lblE}>Desenvolvimiento B (mm)</label><input type="number" style={inpE} placeholder="320" value={estucheForm.desenv_manual_b} onChange={e=>setEF('desenv_manual_b',e.target.value)}/></div>
                </div>
              )}
              {!esRigido&&(
                <div style={{borderTop:'1px solid #F3F4F6',paddingTop:'12px',marginBottom:'12px'}}>
                  <label style={lblE}>Pliego</label>
                  <div style={{display:'flex',gap:'6px',flexWrap:'wrap',marginBottom:'10px'}}>
                    {['70x100','65x90','50x70','personalizado'].map(p=>(
                      <button key={p} type="button" onClick={()=>setEF('pliego',p)}
                        style={{padding:'5px 10px',borderRadius:'7px',border:`1.5px solid ${estucheForm.pliego===p?'#1C3FAA':'#E5E7EB'}`,background:estucheForm.pliego===p?'#EFF6FF':'white',color:estucheForm.pliego===p?'#1C3FAA':'#6B7280',fontSize:'11px',fontWeight:'600',cursor:'pointer'}}>
                        {p}
                      </button>
                    ))}
                  </div>
                  {estucheForm.pliego==='personalizado'&&(
                    <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:'8px'}}>
                      <div><label style={lblE}>Ancho (mm)</label><input type="number" style={inpE} placeholder="600" value={estucheForm.pliego_custom_a} onChange={e=>setEF('pliego_custom_a',e.target.value)}/></div>
                      <div><label style={lblE}>Alto (mm)</label><input type="number" style={inpE} placeholder="800" value={estucheForm.pliego_custom_b} onChange={e=>setEF('pliego_custom_b',e.target.value)}/></div>
                    </div>
                  )}
                </div>
              )}
              <div style={{borderTop:'1px solid #F3F4F6',paddingTop:'12px',marginBottom:'12px'}}>
                {esRigido?(
                  <>
                    <div style={{display:'grid',gridTemplateColumns:'1fr 1fr 1fr',gap:'8px'}}>
                      <div><label style={lblE}>Tiraje base</label><input type="number" style={inpE} placeholder="1000" value={estucheForm.tiraje_rigido} onChange={e=>setEF('tiraje_rigido',e.target.value)}/></div>
                      <div><label style={lblE}>Margen (%)</label><input type="number" style={inpE} placeholder="30" value={estucheForm.margen_estuche} onChange={e=>setEF('margen_estuche',e.target.value)}/></div>
                      <div><label style={lblE}>Costos fijos ($)</label><input type="number" style={inpE} placeholder="0" value={estucheForm.costos_fijos||'0'} onChange={e=>setEF('costos_fijos',e.target.value)}/><span style={{fontSize:'9px',color:'#9CA3AF',display:'block',marginTop:'-8px',marginBottom:'10px'}}>Setup, planchas, troquel</span></div>
                    </div>
                    {(estucheForm.tirajes_extra||[]).map((row,i)=>{
                      const t=Number(row.tiraje)||0;
                      const calcRow=t>0?calcEstuche({...estucheForm,tiraje_rigido:String(t)}):{precio_unitario:0};
                      const autoP=calcRow.precio_unitario;
                      return (
                        <div key={i} style={{display:'grid',gridTemplateColumns:'1fr 1fr auto',gap:'6px',marginBottom:'6px',alignItems:'end'}}>
                          <div>
                            {i===0&&<label style={lblE}>Tiraje adicional</label>}
                            <input type="number" min="1" style={{...inpE,marginBottom:0}} placeholder="Ej: 2000"
                              value={row.tiraje} onChange={e=>setEstucheForm(f=>({...f,tirajes_extra:f.tirajes_extra.map((r,j)=>j===i?{...r,tiraje:e.target.value}:r)}))}/>
                          </div>
                          <div>
                            {i===0&&<label style={lblE}>Precio/u (vacío = auto)</label>}
                            <input type="number" min="0" style={{...inpE,marginBottom:0}} placeholder={autoP>0?String(autoP):'auto'}
                              value={row.precio_override} onChange={e=>setEstucheForm(f=>({...f,tirajes_extra:f.tirajes_extra.map((r,j)=>j===i?{...r,precio_override:e.target.value}:r)}))}/>
                          </div>
                          <button type="button" onClick={()=>setEstucheForm(f=>({...f,tirajes_extra:f.tirajes_extra.filter((_,j)=>j!==i)}))}
                            style={{background:'none',border:'1px solid #fca5a5',borderRadius:'6px',color:'#dc2626',cursor:'pointer',fontSize:'14px',padding:'4px 8px',lineHeight:1,...(i===0?{marginTop:'17px'}:{})}}>×</button>
                        </div>
                      );
                    })}
                    <button type="button" onClick={()=>setEstucheForm(f=>({...f,tirajes_extra:[...(f.tirajes_extra||[]),{tiraje:'',precio_override:''}]}))}
                      style={{width:'100%',padding:'6px',borderRadius:'8px',border:'1px dashed #C7D2FE',background:'#F5F3FF',color:'#1C3FAA',fontSize:'11px',fontWeight:'600',cursor:'pointer',marginBottom:'2px'}}>
                      + Agregar tiraje
                    </button>
                  </>
                ):(
                  <>
                    <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:'8px'}}>
                      <div><label style={lblE}>Costo papel ($/kg)</label><input type="number" style={inpE} placeholder="850" value={estucheForm.costo_kg} onChange={e=>setEF('costo_kg',e.target.value)}/></div>
                      <div><label style={lblE}>Margen (%)</label><input type="number" style={inpE} placeholder="30" value={estucheForm.margen_estuche} onChange={e=>setEF('margen_estuche',e.target.value)}/></div>
                    </div>
                    <label style={lblE}>Tirajes</label>
                    <div style={{display:'flex',gap:'10px',flexWrap:'wrap',marginBottom:'10px'}}>
                      {[['t500','500u'],['t1000','1.000u'],['t5000','5.000u']].map(([k,l])=>(
                        <label key={k} style={{display:'flex',alignItems:'center',gap:'5px',fontSize:'12px',cursor:'pointer'}}>
                          <input type="checkbox" checked={!!estucheForm.tirajes[k]} onChange={e=>setTir(k,e.target.checked)}/>{l}
                        </label>
                      ))}
                      <input type="number" style={{...inpE,width:'90px',margin:0}} placeholder="Otro u." value={estucheForm.tirajes.custom} onChange={e=>setTir('custom',e.target.value)}/>
                    </div>
                  </>
                )}
              </div>
              {esRigido&&res.componentes&&res.componentes.length>0&&(
                <div style={{background:'#F0F9FF',border:'1px solid #BAE6FD',borderRadius:'12px',padding:'14px',marginBottom:'14px'}}>
                  <div style={{display:'flex',alignItems:'center',justifyContent:'space-between',marginBottom:'8px'}}>
                    <div style={{fontSize:'12px',fontWeight:'700',color:'#0369A1'}}>Resultado — {res.tiraje.toLocaleString('es-AR')} unidades</div>
                    <div style={{display:'flex',background:'#E0F2FE',borderRadius:'8px',padding:'2px',gap:'1px'}}>
                      <button type="button" onClick={()=>setPrecioMillar(false)} style={{padding:'3px 10px',borderRadius:'6px',fontSize:'11px',fontWeight:'600',border:'none',cursor:'pointer',background:!precioMillar?'#0369A1':'transparent',color:!precioMillar?'white':'#0369A1'}}>$/u</button>
                      <button type="button" onClick={()=>setPrecioMillar(true)}  style={{padding:'3px 10px',borderRadius:'6px',fontSize:'11px',fontWeight:'600',border:'none',cursor:'pointer',background:precioMillar?'#0369A1':'transparent',color:precioMillar?'white':'#0369A1'}}>$/millar</button>
                    </div>
                  </div>
                  <table style={{width:'100%',borderCollapse:'collapse',fontSize:'11px',marginBottom:'10px'}}>
                    <thead>
                      <tr style={{background:'#0369A1',color:'white'}}>
                        {['Componente','Dim (mm)','Bocas','Pliegos','Peso kg','Costo'].map((h,i)=>(
                          <th key={i} style={{padding:'5px 6px',textAlign:i===0?'left':'right',fontWeight:'600'}}>{h}</th>
                        ))}
                      </tr>
                    </thead>
                    <tbody>
                      {res.componentes.map((c,i)=>(
                        <tr key={i} style={{background:i%2===0?'white':'#F0F9FF',borderBottom:'1px solid #BAE6FD'}}>
                          <td style={{padding:'5px 6px',fontWeight:'600'}}>{c.nombre}</td>
                          <td style={{padding:'5px 6px',textAlign:'right'}}>{c.dA}×{c.dB}</td>
                          <td style={{padding:'5px 6px',textAlign:'right'}}>{c.bocas}</td>
                          <td style={{padding:'5px 6px',textAlign:'right'}}>{c.pliegos}</td>
                          <td style={{padding:'5px 6px',textAlign:'right'}}>{c.peso_kg}</td>
                          <td style={{padding:'5px 6px',textAlign:'right'}}>{c.costo>0?`$${c.costo.toLocaleString('es-AR')}`:'-'}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                  <div style={{display:'grid',gridTemplateColumns:'1fr 1fr 1fr',gap:'6px',marginBottom:'10px'}}>
                    <div style={{background:'white',borderRadius:'8px',padding:'8px',textAlign:'center'}}>
                      <div style={{fontSize:'10px',color:'#6B7280'}}>Costo total mat.</div>
                      <div style={{fontSize:'13px',fontWeight:'700',color:'#111827'}}>{res.costo_total>0?`$${res.costo_total.toLocaleString('es-AR')}`:'-'}</div>
                    </div>
                    <div style={{background:'white',borderRadius:'8px',padding:'8px',textAlign:'center'}}>
                      <div style={{fontSize:'10px',color:'#6B7280'}}>Precio venta</div>
                      <div style={{fontSize:'13px',fontWeight:'700',color:'#0369A1'}}>{res.precio_venta>0?`$${res.precio_venta.toLocaleString('es-AR')}`:'-'}</div>
                    </div>
                    <div style={{background:'white',borderRadius:'8px',padding:'8px',textAlign:'center'}}>
                      <div style={{fontSize:'10px',color:'#6B7280'}}>{precioMillar?'$/millar':'$/u'}</div>
                      <div style={{fontSize:'13px',fontWeight:'700',color:'#111827'}}>{res.precio_unitario>0?`$${(precioMillar?res.precio_unitario*1000:res.precio_unitario).toLocaleString('es-AR')}`:'-'}</div>
                    </div>
                  </div>
                  {(()=>{
                    const todosLosTirajes=[
                      {tiraje:String(estucheForm.tiraje_rigido||''),precio_override:''},
                      ...(estucheForm.tirajes_extra||[]),
                    ].filter(t=>Number(t.tiraje)>0);
                    if(todosLosTirajes.length<2) return null;
                    return (
                      <table style={{width:'100%',borderCollapse:'collapse',fontSize:'11px',marginBottom:'10px'}}>
                        <thead>
                          <tr style={{background:'#0369A1',color:'white'}}>
                            <th style={{padding:'5px 6px',textAlign:'left',fontWeight:'600'}}>Cantidad</th>
                            <th style={{padding:'5px 6px',textAlign:'right',fontWeight:'600'}}>Precio/u</th>
                            <th style={{padding:'5px 6px',textAlign:'right',fontWeight:'600'}}>Subtotal</th>
                          </tr>
                        </thead>
                        <tbody>
                          {todosLosTirajes.map((t,i)=>{
                            const cr=calcEstuche({...estucheForm,tiraje_rigido:t.tiraje});
                            const pu=t.precio_override?Number(t.precio_override):cr.precio_unitario;
                            return (
                              <tr key={i} style={{background:i%2===0?'white':'#F0F9FF',borderBottom:'1px solid #BAE6FD'}}>
                                <td style={{padding:'5px 6px',fontWeight:'600'}}>{Number(t.tiraje).toLocaleString('es-AR')}u</td>
                                <td style={{padding:'5px 6px',textAlign:'right'}}>{pu>0?`$${pu.toLocaleString('es-AR')}`:'-'}</td>
                                <td style={{padding:'5px 6px',textAlign:'right',fontWeight:'700',color:'#0369A1'}}>{pu>0?`$${(Number(t.tiraje)*pu).toLocaleString('es-AR')}`:'-'}</td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    );
                  })()}
                  <button type="button" onClick={()=>transferir(null)}
                    style={{width:'100%',padding:'8px',borderRadius:'8px',border:'none',background:'#1C3FAA',color:'white',fontSize:'12px',fontWeight:'700',cursor:'pointer'}}>
                    {(()=>{const n=(estucheForm.tirajes_extra||[]).filter(t=>Number(t.tiraje)>0).length;return n>0?`↗ Usar en cotización (${n+1} tirajes)`:'↗ Usar en cotización';})()}
                  </button>
                </div>
              )}
              {!esRigido&&(res.dA>0||estucheForm.modo==='manual')&&(
                <div style={{background:'#F0F9FF',border:'1px solid #BAE6FD',borderRadius:'12px',padding:'14px',marginBottom:'14px'}}>
                  <div style={{display:'flex',alignItems:'center',justifyContent:'space-between',marginBottom:'8px'}}>
                    <div style={{fontSize:'12px',fontWeight:'700',color:'#0369A1'}}>Resultado</div>
                    <div style={{display:'flex',background:'#E0F2FE',borderRadius:'8px',padding:'2px',gap:'1px'}}>
                      <button type="button" onClick={()=>setPrecioMillar(false)} style={{padding:'3px 10px',borderRadius:'6px',fontSize:'11px',fontWeight:'600',border:'none',cursor:'pointer',background:!precioMillar?'#0369A1':'transparent',color:!precioMillar?'white':'#0369A1'}}>$/u</button>
                      <button type="button" onClick={()=>setPrecioMillar(true)}  style={{padding:'3px 10px',borderRadius:'6px',fontSize:'11px',fontWeight:'600',border:'none',cursor:'pointer',background:precioMillar?'#0369A1':'transparent',color:precioMillar?'white':'#0369A1'}}>$/millar</button>
                    </div>
                  </div>
                  <div style={{display:'grid',gridTemplateColumns:'1fr 1fr 1fr',gap:'6px',marginBottom:'10px'}}>
                    <div style={{background:'white',borderRadius:'8px',padding:'8px',textAlign:'center'}}>
                      <div style={{fontSize:'10px',color:'#6B7280'}}>Desenvolvimiento</div>
                      <div style={{fontSize:'13px',fontWeight:'700',color:'#111827'}}>{res.dA}×{res.dB} mm</div>
                    </div>
                    <div style={{background:'white',borderRadius:'8px',padding:'8px',textAlign:'center'}}>
                      <div style={{fontSize:'10px',color:'#6B7280'}}>Almas/pliego</div>
                      <div style={{fontSize:'13px',fontWeight:'700',color:'#111827'}}>{res.almas}</div>
                    </div>
                    <div style={{background:'white',borderRadius:'8px',padding:'8px',textAlign:'center'}}>
                      <div style={{fontSize:'10px',color:'#6B7280'}}>Gramaje</div>
                      <div style={{fontSize:'13px',fontWeight:'700',color:'#111827'}}>{estucheForm.gramaje} g/m²</div>
                    </div>
                  </div>
                  {res.rows.length>0&&(
                    <table style={{width:'100%',borderCollapse:'collapse',fontSize:'11px'}}>
                      <thead>
                        <tr style={{background:'#0369A1',color:'white'}}>
                          {['Tiraje','Pliegos','Material kg','Costo mat.','Precio vta.',precioMillar?'$/millar':'$/u',''].map((h,i)=>(
                            <th key={i} style={{padding:'5px 6px',textAlign:i===0?'left':'right',fontWeight:'600'}}>{h}</th>
                          ))}
                        </tr>
                      </thead>
                      <tbody>
                        {res.rows.map((r,i)=>(
                          <tr key={i} style={{background:i%2===0?'white':'#F0F9FF',borderBottom:'1px solid #BAE6FD'}}>
                            <td style={{padding:'5px 6px',fontWeight:'600'}}>{r.tiraje.toLocaleString('es-AR')}u</td>
                            <td style={{padding:'5px 6px',textAlign:'right'}}>{r.pliegos}</td>
                            <td style={{padding:'5px 6px',textAlign:'right'}}>{r.kg}</td>
                            <td style={{padding:'5px 6px',textAlign:'right'}}>{r.costo>0?`$${r.costo.toLocaleString('es-AR')}`:'-'}</td>
                            <td style={{padding:'5px 6px',textAlign:'right',fontWeight:'700',color:'#0369A1'}}>{r.precio>0?`$${r.precio.toLocaleString('es-AR')}`:'-'}</td>
                            <td style={{padding:'5px 6px',textAlign:'right'}}>{r.pu>0?`$${(precioMillar?r.pu*1000:r.pu).toLocaleString('es-AR')}`:'-'}</td>
                            <td style={{padding:'5px 6px',textAlign:'right'}}>
                              <button type="button" onClick={()=>transferir(r)}
                                style={{padding:'3px 8px',borderRadius:'6px',border:'none',background:'#1C3FAA',color:'white',fontSize:'10px',fontWeight:'700',cursor:'pointer'}}>
                                ↗ Usar
                              </button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  )}
                </div>
              )}
              </div>{/* /opacity wrapper */}
            </div>
          </div>
        );
      })()}
      {toast&&(
        <div style={{position:'fixed',bottom:'24px',right:'24px',background:'#16a34a',color:'white',padding:'12px 20px',borderRadius:'10px',fontWeight:'600',fontSize:'13px',zIndex:9998,boxShadow:'0 4px 16px rgba(0,0,0,0.15)',pointerEvents:'none'}}>
          {toast}
        </div>
      )}
    </div>
  );
}
